/*
 * Copyright 2026 DeviceAtlas Limited. All rights reserved.
 * https://deviceatlas.com 
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 65:
/***/ (function(module) {


var Headers = {

  getRequestHeaders: function (args) {

    var _headers = [
      { name: 'Content-Type', value: 'application/json' },
    ];

    if (args && args.version) {
      _headers.push({ name: 'DeviceAssure-Version', value: args.version });
    }

    if (args && args.variants) {
      _headers.push({ name: 'DeviceAssure-Variants', value: args.variants });
    }

    if (args && args.requestId) {
      _headers.push({ name: 'DeviceAssure-ID', value: args.requestId });
    }

    if (args && typeof args.attempt != 'undefined') {
      _headers.push({ name: 'DeviceAssure-Attempt', value: ''  + args.attempt });
    }

    if (args && args.libraryType) {
      _headers.push({ name: 'library-type', value: args.libraryType });
    }

    return _headers;
  }

};

module.exports = Headers;


/***/ }),

/***/ 92:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* jshint strict: false */

var Common = __webpack_require__(782);
const StringUtils = __webpack_require__(151);

var _PERMISSIONS = [
  'accelerometer',
  'accessibility-events',
  'ambient-light-sensor',
  'background-sync',
  'camera',
  'clipboard-read',
  'clipboard-write',
  'geolocation',
  'gyroscope',
  'magnetometer',
  'microphone',
  'midi',
  'notifications',
  'payment-handler',
  'persistent-storage',
  'push',
  'speaker-selection'
];

/**
 * This is collected to help identify firefox private browsing mode.
 * @param webJsProps
 * @private
 */
/* istanbul ignore next */
function detectServiceWorker() {
  return Common.collectData(function () {
    return typeof navigator.serviceWorker !== 'undefined';
  });
}

/**
 * Helps to identify private mode IE.
 * @param webJsProps
 * @private
 */
/* istanbul ignore next */
function collectMsSaveBlob() {
  if (typeof navigator.msSaveBlob !== 'undefined') {
    return Common.collectData(function () {
      return navigator.msSaveBlob;
    });
  }
}

/**
 * Collects the max touch points for a browser
 * @param webJsProps
 * @private
 */
/* istanbul ignore next */
function collectMaxTouchPoints() {
  return Common.collectData(function () {
    return navigator.maxTouchPoints;
  });
}

function isMediaDevicesAvailable() {
  return typeof navigator.mediaDevices !== 'undefined';
}

function isAppleUserAgent(_navigator) {
  
  var ua = getUserAgent(_navigator);

  return !!ua && /iPad|iPhone|iPod|Macintosh/.test(ua);
}

function getHardwareConcurrency(_navigator) {
  return _navigator.hardwareConcurrency;
}

function getPlatform(_navigator) {
  return _navigator.platform;
}

function getUserAgent(_navigator) {
  return (_navigator || {}).userAgent;
}

/**
 * Attempts to collect the language information
 */
/* istanbul ignore next */
var collectLanguage = function () {
  return Common.collectData(function () {
    return navigator.language;
  });
};

/**
 * Attempts to collect the languages information
 */
/* istanbul ignore next */
var collectLanguages = function () {
  return Common.collectData(function () {
    return navigator.languages;
  });
};

/**
 * Returns whether the plugins key is present in the navigator object
 *
 * @returns {boolean}
 */
/* istanbul ignore next */
var isNavigatorPluginsAvailable = function () {
  return 'plugins' in navigator || typeof navigator.plugins !== 'undefined';
};


/**
 * Collects the navigator plugins prototype
 * https://github.com/infosimples/detect-headless/blob/master/scripts/detect_headless.js
 * When this is false, its a headless browser
 * @returns {*}
 * @private
 */
var _collectPluginsPrototypes = function () {
  if (!isNavigatorPluginsAvailable()) {
    return null;
  }

  return Common.collectData(function () {
    var value = PluginArray.prototype ===  Object.getPrototypeOf(navigator.plugins);
    if (navigator.plugins.length > 0) {
      value = value && Plugin.prototype === Object.getPrototypeOf(navigator.plugins[0]);
    }
    return value;
  });
};

/**
 * This is used to help identify chrome incognito mode from version 76 and onwards.
 * @param args - { resolve, reject }
 * @param _apiData - {}
 * @private
 */
/* istanbul ignore next */
function collectWebkitTemporaryStorageQuota(args, _apiData) {

  if (navigator.webkitTemporaryStorage && navigator.webkitTemporaryStorage.queryUsageAndQuota) {
    navigator.webkitTemporaryStorage.queryUsageAndQuota(function (usage, quota) {
        _apiData.webkitTemporaryStorage_used = Common.collectData(function () { return usage; });
        _apiData.webkitTemporaryStorage_quota = Common.collectData(function () { return quota; });

        if (args && args.resolve) {
          args.resolve({
            webkitTemporaryStorage_used: _apiData.webkitTemporaryStorage_used,
            webkitTemporaryStorage_quota: _apiData.webkitTemporaryStorage_quota
          });
        }
      },
      function (error) {

        _apiData.webkitTemporaryStorage_used = Common.collectData(function () { return -1; });
        _apiData.webkitTemporaryStorage_used.e = true;

        _apiData.webkitTemporaryStorage_quota = Common.collectData(function () { return -1; });
        _apiData.webkitTemporaryStorage_quota.e = true;

        if (args && args.resolve) {
          args.resolve({
            webkitTemporaryStorage_used: _apiData.webkitTemporaryStorage_used,
            webkitTemporaryStorage_quota: _apiData.webkitTemporaryStorage_quota
          });
        }
      });
  }
  else if (args && args.resolve) {
    args.resolve();
  }
}

/**
 * Looks at the Permissions API and records the state of each permission.
 *
 * @params args - { resolve, reject }
 */
/* istanbul ignore next */
function detectPermissionsApi(args, _apiData) {

  var isAvailable = navigator && !!navigator.permissions;
  var isQueryPresent = isAvailable && !!navigator.permissions.query && typeof navigator.permissions.query === 'function';

  _apiData.permissions = {
    available: isAvailable,
    query: isQueryPresent,
    inComplete: [],
    completed: {},
    failed: 0
  };

  if (!isQueryPresent) {
    if (args && args.resolve) {
      args.resolve(_apiData.permissions);
    }
    return _apiData.permissions;
  }

  var recordFailedAttempt = function (error, _args, _apiData) {
    _apiData.permissions.failed++;

    if (_args && _args.resolve) {
      _args.resolve();
    }
  };

  var onSuccess = function (result, _args, _apiData) {
    if (!result || !result.name || !result.state) {
      return recordFailedAttempt(result, _args, _apiData);
    }
    var name = result.name;
    var index = _apiData.permissions.inComplete.indexOf(name);
    _apiData.permissions.inComplete.splice(index, 1);
    _apiData.permissions.completed[name] = { state: result.state, onChange: !!result.onchange };

    if ('notifications' === name) {
      try {
        _apiData.permissions.completed[name].permission = Notification.permission;
      }
      catch (e) {
        recordFailedAttempt(e, null, _apiData);
      }
    }

    if (_args && _args.resolve) {
      _args.resolve(_apiData.permissions.completed[name]);
    }
  };

  var permissionsPromise = function (permission) {
    _apiData.permissions.inComplete.push(permission);

    return new Promise(function (resolve, reject) {
      navigator.permissions.query({ name: permission })
        .then(function(result) {
          onSuccess(result, { resolve: resolve }, _apiData);
        })
        .catch(function(result) {
          recordFailedAttempt(result, { resolve: resolve }, _apiData);
        });
    });
  };

  var promises = [];
  for (var i = 0; i < _PERMISSIONS.length; i++) {
    promises.push(permissionsPromise(_PERMISSIONS[i]));
  }

  Promise.all(promises).then(function () {
    if (args && args.resolve) {
      args.resolve(_apiData.permissions);
    }
  });

  return _apiData.permissions;
}

/**
 * Attempts to collect the battery manager information
 */
/* istanbul ignore next */
function collectBatteryManager(args, _apiData) {

  var isPresent = !!navigator.getBattery && typeof navigator.getBattery === 'function';

  _apiData.getBattery = { available: isPresent };

  if (!_apiData.getBattery.available) {
    if (args && args.resolve) {
      args.resolve(_apiData.getBattery);
    }
    return _apiData.getBattery;
  }

  var onSuccess = function (battery) {
    _apiData.getBattery.charging = battery.charging;
    _apiData.getBattery.level = battery.level;
    _apiData.getBattery.chargingTime = battery.chargingTime;
    _apiData.getBattery.dischargingTime = battery.dischargingTime;

    if (args && args.resolve) {
      args.resolve(_apiData.getBattery);
    }
  };

  var onError = function () {
    _apiData.getBattery.failed = true;

    if (args && args.resolve) {
      args.resolve(_apiData.getBattery);
    }
  };

  navigator.getBattery()
    .then(onSuccess)
    .catch(onError);

  return _apiData.getBattery;
}

/**
 * Collects the navigator.mediaDevices in the browser
 * @param args
 * @param _apiData
 * @private
 */
/* istanbul ignore next */
function collectMediaDevices(args, _apiData) {

  if (!isMediaDevicesAvailable()) {

    if (args && args.resolve) {
      args.resolve();
    }
    return;
  }

  // Handling how the media devices are obtained. Forcing a wait on promise before sending to API
  navigator.mediaDevices.enumerateDevices()
    .then(function(devices) {
      var text = '';

      for (var _i = 0; _i < devices.length; _i++) {
        if (devices[_i]) {
          text = text + devices[_i].kind + ': ' + devices[_i].label + ' id = ' + devices[_i].deviceId + '\n';
        }
      }
      _apiData['navigator.mediaDevices'] = text;

      if (args && args.resolve) {
        args.resolve(text);
      }
    })
    .catch(function(err) {
      if (args && args.resolve) {
        args.resolve();
      }
    });
}

/**
 * Converts the plugin object to a base64 string
 * @param _plugin
 * @returns {string|null}
 */
/* istanbul ignore next */
var _convertPlugin = function (_plugin) {
  if (_plugin && typeof _plugin !== 'undefined') {
    return btoa(_plugin.name + StringUtils.__STRING_SEPARATOR + _plugin.filename + StringUtils.__STRING_SEPARATOR + _plugin.description);
  }
  return null;
};

/**
 * Collects all the navigator plugins if they are available
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/plugins
 * @returns {{a: boolean, e: boolean, v: *[]}}
 * @private
 */
/* istanbul ignore next */
var _collectNavigatorPlugins = function () {

  return Common.collectData(function () {
    if (!isNavigatorPluginsAvailable()) {
      return null;
    }
    var values = [];
    for (var i = 0; i < navigator.plugins.length; i++) {
      if (navigator.plugins[i]) {
        values.push(_convertPlugin(navigator.plugins[i]));
      }
    }

    return values;
  });
};

/**
 * Collects the navigator vendor property
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/vendor
 * @returns {*}
 * @private
 */
/* istanbul ignore next */
var collectNavigatorVendor = function () {

  if (typeof navigator.vendor === 'undefined') {
    return null;
  }

  return Common.collectData(function () {
    return navigator.vendor;
  });
};

/**
 * Collects the navigator vendorSub property
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/vendorSub
 * @returns {*}
 * @private
 */
/* istanbul ignore next */
var collectNavigatorVendorSub = function () {
  if (typeof navigator.vendorSub === 'undefined') {
    return null;
  }

  return Common.collectData(function () {
    return navigator.vendorSub;
  });
};


/**
 * Attempts to identify if the brave properties are present.
 * @returns
 */
/* istanbul ignore next */
var _collectBraveData = function () {
  return {
    available: (typeof navigator.brave !== 'undefined' && typeof navigator.brave.isBrave === 'function')
  };
};

/**
 * Collects whether the js engine is Apple's
 * @private
 */
/* istanbul ignore next */
var _collectIsAppleDevice = function () {

  if (isAppleUserAgent(navigator)) {
    return Common.collectData(function () {
      return true;
    });
  }

};


var NavigatorCollector = {
  detectServiceWorker: detectServiceWorker,
  collectMsSaveBlob: collectMsSaveBlob,
  collectMaxTouchPoints: collectMaxTouchPoints,
  isMediaDevicesAvailable: isMediaDevicesAvailable,
  isAppleUserAgent: isAppleUserAgent,
  getHardwareConcurrency: getHardwareConcurrency,
  getPlatform: getPlatform,
  getUserAgent: getUserAgent,
  collectLanguage: collectLanguage,
  collectLanguages: collectLanguages,
  isNavigatorPluginsAvailable: isNavigatorPluginsAvailable,
  convertPlugin: _convertPlugin,
  collectNavigatorPlugins: _collectNavigatorPlugins,
  collectNavigatorVendor: collectNavigatorVendor,
  collectNavigatorVendorSub: collectNavigatorVendorSub,
  collectBraveData: _collectBraveData,
  collectPluginsPrototypes: _collectPluginsPrototypes,
  collectIsAppleDevice: _collectIsAppleDevice,

  collectWebkitTemporaryStorageQuota: collectWebkitTemporaryStorageQuota,
  detectPermissionsApi: detectPermissionsApi,
  collectBatteryManager: collectBatteryManager,
  collectMediaDevices: collectMediaDevices,

  collect: function (webJsProps) {

    if (!webJsProps) {
      return;
    }

    var dataCollectors = [
      { key: 'navigator_language',          collection: collectLanguage },
      { key: 'navigator_languages',         collection: collectLanguages },
      { key: 'navigator_maxTouchPoints',    collection: collectMaxTouchPoints },
      { key: 'serviceWorker',               collection: detectServiceWorker },
      { key: 'navigator_plugins',           collection: _collectNavigatorPlugins },
      { key: 'navigator_vendor',            collection: collectNavigatorVendor },
      { key: 'navigator_vendorSub',         collection: collectNavigatorVendorSub },
      { key: 'brave',                       collection: _collectBraveData },
      { key: 'apple',                       collection: _collectIsAppleDevice },
      { key: 'navigator_plugins_prototype', collection: _collectPluginsPrototypes },
      { key: 'msSaveBlob',                  collection: collectMsSaveBlob, conditions: function (value) { return typeof value !== 'undefined'; } }
    ];

    for (var i = 0; i < dataCollectors.length; i++) {
      var collector = dataCollectors[i];
      var allowCollect = collector.conditions || function () { return true; };
      var value = collector.collection(webJsProps);

      if (allowCollect(value)) {
        webJsProps[collector.key] = value;
      }
    }
  },
  getCollectionsForAsync: function () {
    return [
      { name: 'navigator_mediaDevices',           collection: collectMediaDevices },
      { name: 'navigator_getBattery',             collection: collectBatteryManager },
      { name: 'navigator_permissions',            collection: detectPermissionsApi },
      { name: 'navigator_webkitTemporaryStorage', collection: collectWebkitTemporaryStorageQuota }
    ];
  }
};

module.exports = NavigatorCollector;


/***/ }),

/***/ 151:
/***/ (function(module) {


var StringUtils = {


  __STRING_SEPARATOR: '__',

  /**
   * Removes the spaces found at the end of the string.
   * @param str
   * @param character
   * @returns {string|string|*}
   */
  trimEnd: function(str, character) {
      if (str === null || str === undefined || typeof str !== 'string') {
        return null;
      }

      while (str.charAt(str.length - 1) === (character || ' ')) {
        str = str.slice(0, -1);
      }

      return str;
  },

  /**
   * Removes the spaces found at the start of the string.
   * @param str
   * @param character
   * @returns {string|string|*}
   */
  trimStart: function(str, character) {
    if (str === null || str === undefined || typeof str !== 'string') {
      return null;
    }

    while (str.charAt(0) === (character || ' ')) {
      str = str.slice(1);
    }

    return str;
  },

  /**
   * Trims the start and end of a string.
   *
   * @param str
   * @param character
   * @returns {string|*}
   * @private
   */
  trim: function(str, character) {
    var _str = this.trimStart(str, character);
    return this.trimEnd(_str, character);
  }
};

module.exports = StringUtils;

/***/ }),

/***/ 197:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* jshint strict: false */
const Common = __webpack_require__(782);

/**
 * Attempts to identify if the Opera properties are present.
 * @returns {{available: boolean}}
 * @private
 */
/* istanbul ignore next */
var _collectOperaData = function () {
  return {
    available: typeof window.opr !== 'undefined'
  };
};

/**
 * Attempts to identify if the Safari properties are present.
 * @returns {{available}}
 * @private
 */
/* istanbul ignore next */
var _collectSafariData = function () {

  return {
    available: typeof window.safari !== 'undefined' && typeof safari.pushNotification === 'function'
  };
};

/**
 * Collects the presence of the window.chrome property
 * @private
 */
/* istanbul ignore next */
var _collectWindowChrome = function () {

  if (typeof window.chrome !== 'undefined') {
    return Common.collectData(function () { return !!window.chrome; });
  }
};

/**
 * Detects if the current window is contained within an iframe
 * @param webJsProps
 * @private
 */
/* istanbul ignore next */
var _collectWindowIframe = function (webJsProps) {
  return Common.collectData(function () {
    return window && window.self !== window.top;
  });
};


var WindowCollector = {
  collectOperaData: _collectOperaData,
  collectSafariData: _collectSafariData,
  collectWindowChrome: _collectWindowChrome,
  collectWindowIframe: _collectWindowIframe,

  collect: function (webJsProps) {

    if (!webJsProps) {
      return;
    }

    var dataCollectors = [
      { key: 'opera',         collection: _collectOperaData },
      { key: 'safari',        collection: _collectSafariData },
      { key: 'window_chrome', collection: _collectSafariData },
      { key: 'window_iframe', collection: _collectWindowIframe },
    ];

    for (var i = 0; i < dataCollectors.length; i++) {
      var collector = dataCollectors[i];
      var allowCollect = collector.conditions || function () { return true; };
      var value = collector.collection(webJsProps);

      if (allowCollect(value)) {
        webJsProps[collector.key] = value;
      }
    }
  },
  getCollectionsForAsync: function () {
    return [];
  }
};

module.exports = WindowCollector;


/***/ }),

/***/ 221:
/***/ (function(module) {

/* istanbul ignore next */
var DeviceAssure = function (library, _metrics) {
  window.DeviceAssure = {
    load: function (args) {
      _metrics.entryPoint = 'DeviceAssure';
      library.load(args);
    },
    qr: function (args) {
      _metrics.entryPoint = 'DeviceAssure';
      library.qr(args);
    },
    parseQrRedirect: function (data, args) {
      _metrics.entryPoint = 'DeviceAssure';
      return library.parseQrRedirect(data, args);
    }
  };
};

/* istanbul ignore next */
var DeviceValidation = function (library, _metrics) {
// Keep the DeviceValidation name for backwards compatibility, but it is deprecated and will be removed in a future version.
  /** @deprecated */
  window.DeviceValidation = {
    load: function (args) {
      _metrics.entryPoint = 'DeviceValidation';
      library.load(args);
    },

    /** @deprecated */
    check: function (licence, onSuccess, onError, payload, currentUrl, overrideLoading, overridingURLs) {
      _metrics.entryPoint = 'DeviceValidation';
      return library.check(licence, onSuccess, onError, payload, currentUrl, overrideLoading, overridingURLs);
    },
    /** @deprecated */
    checkIMEI: function (imei, params) {
      _metrics.entryPoint = 'DeviceValidation';
      return library.checkIMEI(imei, params);
    },
    /** @deprecated */
    getData: function (callback) {
      _metrics.entryPoint = 'DeviceValidation';
      return library.getData(callback);
    }
  };
};

var generate = function (library, _metrics) {
  DeviceAssure(library, _metrics);
  DeviceValidation(library, _metrics);
};

module.exports = {
  generate: generate
};

/***/ }),

/***/ 357:
/***/ (function(module) {


var Requests = {

  getXMLHttpFactories: function() {
    return [
      function () { return new XMLHttpRequest(); },
      function () { return new ActiveXObject('Msxml3.XMLHTTP'); },
      function () { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); },
      function () { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); },
      function () { return new ActiveXObject('Msxml2.XMLHTTP'); },
      function () { return new ActiveXObject('Microsoft.XMLHTTP');  }
    ];
  },

  createXMLHTTPObject: function() {
    var xmlHTTP = false;
    var XMLHttpFactories = this.getXMLHttpFactories();
    for (var i = 0; i < XMLHttpFactories.length; i++) {
      try {
        xmlHTTP = XMLHttpFactories[i]();
      }
      catch (e) {
        continue;
      }
      break;
    }

    return xmlHTTP;
  },

  init: function (args) {
    var xhr = this.createXMLHTTPObject();

    if (!xhr) {
      // Could not create XMLHttpRequest, do nothing
      return;
    }

    if (!args.url) {
      throw new Error('URL is required to make a request.');
    }

    xhr.open('POST', args.url, true);

    if (args.headers) {
      for (var i = 0; i < args.headers.length; i++) {
        xhr.setRequestHeader(args.headers[i].name, args.headers[i].value);
      }
    }
    xhr.onerror = args.onError;
    xhr.onreadystatechange = args.onReadyStateChange;

    return xhr;
  }

};

module.exports = Requests;

/***/ }),

/***/ 444:
/***/ (function(module) {

// app/properties/automation.properties.js
var AutomationProperties = {
  /**
   * Internal cache for storing keys
   * @private
   */
  _cache: {},

  /**
   * Detects the geb bot
   * @returns {{a: boolean, e: boolean, v: *[]}}
   */
  _detectGeb: function() {
    return this._detectKeys(['geb']);
  },

  /**
   * https://fminer.findmysoft.com/
   * @returns {{a: boolean, e: boolean, v: *[]}}
   */
  _detectFMiner: function() {
    return this._detectKeys(['fmget_targets']);
  },

  /**
   * Collects the awesomium keys
   * https://developer.valvesoftware.com/wiki/Implementing_Awesomium
   *
   * Seems to be dead
   *
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectAwesomium: function () {
    return this._detectKeys(['awesomium']);
  },

  /**
   * https://github.com/chromiumembedded/cef
   * Seems to detect this
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectCef: function () {
    return this._detectKeys(['RunPerfTest']);
  },

  /**
   * https://cefsharp.github.io/
   * https://github.com/cefsharp/CefSharp
   * Seems to detect this
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectCefSharp: function () {
    return this._detectKeys(['Cef']);
  },

  /**
   * Collects keys used for web automation
   *  window
   *  'webdriver',
   *  '__webdriverFunc',
   *  '__lastWatirAlert',
   *  '__lastWatirConfirm',
   *  '__lastWatirPrompt',
   *  '_WEBDRIVER_ELEM_CACHE',
   *  'ChromeDriverw'
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectWebdriverWindowKeys: function () {
    return this._detectKeys([
      'lastWatir',
      'driver',
      'asyncScriptInfo',
      'driver'
    ]);
  },

  /**
   * Collects keys used for web automation
   * 'webdriver',
   *  '__webdriverFunc',
   *  '__lastWatirAlert',
   *  '__lastWatirConfirm',
   *  '__lastWatirPrompt',
   *  '_WEBDRIVER_ELEM_CACHE',
   *  'ChromeDriverw'
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectWebdriverDocumentKeys: function () {
    return this._detectKeys([
      'lastWatir',
      'driver',
      'asyncScriptInfo',
      'driver'
    ], 'document');
  },

  /**
   * Detects the presence of any phantom keys
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectPhantomKeys: function () {
    return this._detectKeys(['Phantom']);
  },

  /**
   * Detects the presence of any rhino keys
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectRhinoKeys: function () {
    return this._detectKeys(['rhino', 'spawn']);
  },

  /**
   * Detects the presence of any rhino keys
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectCouchJS: function () {
    return this._detectKeys(['couch', 'emit']);
  },

  /**
   * Detects the presence of any nodejs keys
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectBufferKeys: function () {
    return this._detectKeys(['Buffer']);
  },

  /**
   * Detects the presence of any domAutomation keys. Used by BrowserStack and the like
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectDomAutomationKeys: function () {
    return this._detectKeys(['domAutomation']);
  },

  /**
   * Detects the presence of any Karma keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectKarmaKeys: function () {
    return this._detectKeys(['karma']);
  },

  /**
   * Detects the presence of any Test keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectTestKeys: function () {
    return this._detectKeys(['test', 'describe', 'fit', 'xit', 'expect', 'beforeEach', 'afterEach', 'beforeAll', 'afterAll']);
  },

  /**
   * Detects the presence of any Chrome Driver keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectChromeDriver: function () {
    return this._detectKeys(['cdc']);
  },

  /**
   * Detects the presence of any Nightmare keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectNightmareInWindow: function () {
    return this._detectKeys(['Nightmare']);
  },

  /**
   * Detects the presence of any Nightmare keys in the document object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectNightmareInDocument: function () {
    return this._detectKeys(['Nightmare'], 'document');
  },

  /**
   * Detects the presence of any Cypress keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectCypressInWindow: function () {
    return this._detectKeys(['Cypress']);
  },

  /**
   * Detects the presence of any Cypress keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectCypressInDocument: function () {
    return this._detectKeys(['Cypress'], 'document');
  },

  /**
   * Detects the presence of any Selenium keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectSeleniumInWindow: function () {
    return this._detectKeys(['Selenium']);
  },

  /**
   * Detects the presence of any Selenium keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectSeleniumInDocument: function () {
    return this._detectKeys(['Selenium'], 'document');
  },

  /**
   * Detects the presence of any Document keys in the document object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectDocumentKeys: function () {
    return this._detectKeys([
      'func',
      'fn',
      'evaluate',
      'unwrapped',
      'driver',
      'fx',
      'playwright',
      'pw',
      '_'
    ], 'document');
  },

  /**
   * Detects the presence of any Document keys in the document object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectWindowKeys: function () {
    return this._detectKeys([
      'webdriver',
      'fingerprint',
      'playwright',
      'puppeteer',
      'phantom',
      'stealth',
      '_injected',
      '__'
    ], 'window');
  },

  /**
   * Detects the presence of any keys in the object passed in
   * @param detections
   * @param type
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  _detectKeys: function (detections, type) {
    var _result = { a: false, v: [], e: false };
    var foundKeys = {};
    var _keys;

    if (type === 'document') {
      _keys = this._getDocumentKeys();
    }
    else if (type === 'navigator') {
      _keys = this._getNavigatorKeys();
    }
    else {
      _keys = this._getWindowKeys();
    }

    for (var i = 0; i < _keys.length; i++) {
      var _key = _keys[i];
      if (!_key) {
        continue;
      }

      for (var j = 0; j < detections.length; j++) {
        try {
          var detection = detections[j];
          if (_key.toLowerCase().indexOf(detection.toLowerCase()) > -1) {
            foundKeys[_key] = i;
          }
        } catch (e) {
          _result.e = true;
        }
      }
    }

    _result.v = Object.keys(foundKeys);
    _result.a = _result.v.length > 0;
    return _result;
  },

  /**
   * Returns a list of keys within the window object
   * @param flush
   * @returns {*|*[]}
   * @private
   */
  _getWindowKeys: function (flush) {
    try {
      return this.__getCacheKey(flush, 'window', window);
    }
    catch (e) {
      return [];
    }
  },

  /**
   * Returns a list of keys within the document object
   * @param flush
   * @returns {*|*[]}
   * @private
   */
  _getDocumentKeys: function (flush) {
    try {
      return this.__getCacheKey(flush, 'document', document);
    }
    catch (e) {
      return [];
    }
  },

  /**
   * Returns a list of keys within the navigator object
   * @param flush
   * @returns {*|*[]}
   * @private
   */
  _getNavigatorKeys: function (flush) {
    try {
      return this.__getCacheKey(flush, 'navigator', navigator);
    }
    catch (e) {
      return [];
    }
  },

  /**
   * Gets a list of keys within the object passed in and stores that list in the cache.
   * @param flush
   * @param key
   * @param obj
   * @returns {*}
   * @private
   */
  __getCacheKey: function (flush, key, obj) {
    if (flush && !!this._cache[key]) {
      delete this._cache[key];
    }

    if (!this._cache[key]) {
      this._cache[key] = Object.keys(obj);
    }

    return this._cache[key];
  },

  /**
   * Flushes the internal cache
   * @private
   */
  flushCache: function () {
    if (this._cache) {
      try {
        var _cacheKeys = Object.keys(this._cache);
        for (var i = 0; i < _cacheKeys.length; i++) {
          delete this._cache[_cacheKeys[i]];
        }
        this._cache = {};
      }
      catch(e) {}
    }
  },

  /**
   * Collects all automation properties into webJsProps
   * @param webJsProps
   */
  collect: function (webJsProps) {
    if (!webJsProps || typeof webJsProps !== 'object') {
      return;
    }

    var dataCollectors = [
      { key: 'phantom',            collection: this._detectPhantomKeys.bind(this) },
      { key: 'rhino',              collection: this._detectRhinoKeys.bind(this) },
      { key: 'buffer',             collection: this._detectBufferKeys.bind(this) },
      { key: 'domAutomation',      collection: this._detectDomAutomationKeys.bind(this) },
      { key: 'couch',              collection: this._detectCouchJS.bind(this) },
      { key: 'cdc',                collection: this._detectChromeDriver.bind(this) },
      { key: 'karma',              collection: this._detectKarmaKeys.bind(this) },
      { key: 'geb',                collection: this._detectGeb.bind(this) },
      { key: 'fminer',             collection: this._detectFMiner.bind(this) },
      { key: 'awesomium',          collection: this._detectAwesomium.bind(this) },
      { key: 'cef',                collection: this._detectCef.bind(this) },
      { key: 'cefsharp',           collection: this._detectCefSharp.bind(this) },
      { key: 'webdriver_window',   collection: this._detectWebdriverWindowKeys.bind(this) },
      { key: 'webdriver_document', collection: this._detectWebdriverDocumentKeys.bind(this) },
      { key: 'window_nightmare',   collection: this._detectNightmareInWindow.bind(this) },
      { key: 'document_nightmare', collection: this._detectNightmareInDocument.bind(this) },
      { key: 'window_selenium',    collection: this._detectSeleniumInWindow.bind(this) },
      { key: 'document_selenium',  collection: this._detectSeleniumInDocument.bind(this) },
      { key: 'window_cypress',     collection: this._detectCypressInWindow.bind(this) },
      { key: 'document_cypress',   collection: this._detectCypressInDocument.bind(this) },
      { key: 'test',               collection: this._detectTestKeys.bind(this) },

      { key: 'document',           collection: this._detectDocumentKeys.bind(this) },
      { key: 'window',             collection: this._detectWindowKeys.bind(this) },
    ];

    for (var i = 0; i < dataCollectors.length; i++) {
      try {
        var collector = dataCollectors[i];
        var allowCollect = collector.conditions || function () { return true; };
        var value = collector.collection(webJsProps);

        if (allowCollect(value) && value.a) {
          webJsProps[collector.key] = value;
        }
      }
      catch (e) {
        // Ignore individual collection errors
      }
      finally {
        this.flushCache();
      }
    }
  },

  /**
   * Placeholder for async collections
   * @returns {Array}
   */
  getCollectionsForAsync: function () {
    return [];
  }
};

module.exports = AutomationProperties;

/***/ }),

/***/ 473:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* istanbul ignore next */
/**
 * DeviceAssure QR Code module. Includes methods to generate QR code script tags and parse redirect data.
 *
 * @type {{
 * getParams: function(*): *[],
 * generateSrc: function(*): string,
 * generateScriptTag: function(*, *): HTMLScriptElement,
 * generate: function(*): void,
 * parseRedirect: function(*, *): (*|string)
 * }}
 */
var Qr = {
  /**
   * Converts the args into an array of key/value pairs for URL parameters.
   * @param args
   * @returns {*[]}
   */
  getParams: function(args) {
    var params = [];
    if (args) {
      if (args.licence) {
        params.push({ key: 'dv-licenceKey', value: args.licence });
      }
      if (typeof args.size !== 'undefined') {
        params.push({ key: 'dv-size', value: args.size });
      }
      if (typeof args.json !== 'undefined') {
        params.push({ key: 'dv-json', value: args.json });
      }
      if (args.scannedMessage) {
        params.push({ key: 'dv-scanned-message', value: args.scannedMessage });
      }
      if (args.expiredMessage) {
        params.push({ key: 'dv-expired-message', value: args.expiredMessage });
      }
      if (args.lifecycle) {
        params.push({ key: 'dv-lifecycle', value: args.lifecycle });
      }
      if (args.responseDelay) {
        params.push({ key: 'dv-response-delay', value: args.responseDelay });
      }
      if (args.deviceRedirect) {
        params.push({ key: 'dv-device-redirect', value: args.deviceRedirect });
      }
      if (args.redirect) {
        params.push({ key: 'dv-redirect', value: args.redirect });
      }
      if (args.destination) {
        params.push({ key: 'dv-destination', value: args.destination });
      }

      if (typeof args.imei !== 'undefined') {
        var IMEI = __webpack_require__(718);
        if (IMEI.validate(args.imei, {}, undefined)) {
          params.push({ key: 'dv-imei', value: args.imei });
        }
      }

      // Tags get transformed in to: `dv-tags=key1:value1,key2:value2`
      if (typeof args.tags !== 'undefined') {
        var CustomTags = __webpack_require__(803);
        if (CustomTags.validateTags(args.tags)) {
          var tagsValue = '';
          for (var _i = 0; _i < args.tags.length; _i++) {
            if (args.tags[_i]) {
              tagsValue += args.tags[_i].key + ':' + args.tags[_i].value + ',';
            }
          }
          if (tagsValue[tagsValue.length - 1] === ',') {
            tagsValue = tagsValue.slice(0, tagsValue.length - 1);
          }

          params.push({ key: 'dv-tags', value: tagsValue });
        }
      }
    }
    return params;
  },

  /**
   * Creates the src URL for the DeviceAssure QR code script.
   * @param args
   * @returns {string}
   */
  generateSrc: function(args) {
    var params = this.getParams(args);

    var queryString = '';
    if (params && params.length > 0) {
      for (var i = 0; i < params.length; i++) {
        queryString += params[i].key + '=' + encodeURIComponent(params[i].value) + '&';
      }
      queryString = queryString.slice(0, queryString.length - 1); // Remove trailing '&'
    }
    var scriptSrc = "https://qr-code.deviceatlas.com" + '/v2/api/snippet.js' + (queryString ? '?' + queryString : '');

    return scriptSrc;
  },

  /**
   * Generates a script tag to load the DeviceAssure QR code script.
   * @param args
   * @param _qrCallback
   * @returns {HTMLScriptElement}
   */
  generateScriptTag: function(args, _qrCallback) {

    if (!_qrCallback || typeof _qrCallback !== 'function') {
      throw new Error('QR callback function is required');
    }

    var scriptSrc = this.generateSrc(args);

    // Remove existing script if present
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length - 1; i >= 0; i--) {
      if (scripts[i] && scripts[i].id === 'deviceassure-qr-script') {
        scripts[i].parentNode.removeChild(scripts[i]);
      }
    }
    var script = document.createElement('script');
    script.id = 'deviceassure-qr-script';
    if (args && args.script) {
      if (args.script.nonce) {
        script.nonce = args.script.nonce;
      }
      if (typeof args.script.async !== 'undefined') {
        script.async = args.script.async;
      }
      if (typeof args.script.defer !== 'undefined') {
        script.defer = args.script.defer;
      }
    }

    // remove the global callback if it already exists to avoid conflicts with multiple QR code generations on the same page
    if (typeof window._deviceAssureResultReceived !== 'undefined') {
      delete window._deviceAssureResultReceived;
    }
    window._deviceAssureResultReceived = _qrCallback;

    script.src = scriptSrc;
    script.onload = function() {
      try {
        if (window._setupDeviceAssure) {
          window._setupDeviceAssure();
        }
      }
      catch (e) {
        window._deviceAssureResultReceived({
          message: 'Error loading DeviceAssure QR Code script',
          error: e.message
        });
      }
      sessionStorage.removeItem('deviceassure-qr-loading');
    };
    script.onerror = function(e) {
      window._deviceAssureResultReceived({
        message: 'Error loading DeviceAssure QR Code script',
        error: (e && e.message) || e
      });
      sessionStorage.removeItem('deviceassure-qr-loading');
    };

    // Clear loading flag after 5 seconds in case of unexpected issues
    setTimeout(function() {
      sessionStorage.removeItem('deviceassure-qr-loading');
    }, 5 * 1000);

    return script;
  },

  /**
   * Generates and displays a DeviceAssure QR code in the specified container.
   *   licence: string,
   *   size: number,
   *   json: boolean,
   *   scannedMessage: string,
   *   expiredMessage: string,
   *   lifecycle: string,
   *   redirect: string,
   *   responseDelay: number,
   *   deviceRedirect: string,
   *
   *   script: {
   *     nonce: string,
   *     async: boolean,
   *     defer: boolean
   *   }, // args for script tag
   *
   *   containerId: string, // CSS containerId for the container to insert the QR code into
   *   callback: function // Callback function to handle messages
   * @param args
   */
  generate: function(args) {
    try {
      if (!!sessionStorage.getItem('deviceassure-qr-loading')) {
        return;
      }
      sessionStorage.setItem('deviceassure-qr-loading', JSON.stringify({ timestamp: Date.now() }));

      var _qrCallback = (args && typeof args.callback === 'function') ? args.callback : function(message) {
        console.log('DeviceAssure QR Code message', message);
      };

      var script = this.generateScriptTag(args, _qrCallback);

      var container = document.getElementById('deviceassure');
      if (container) {
        container.remove();
      }
      container = document.createElement('div');
      container.id = 'deviceassure';

      var containerId = (args && args.containerId) ? args.containerId : 'deviceassure-qr-container';
      var app = document.getElementById(containerId);
      if (!app) {
        app = document.createElement('div');
        app.id = containerId;
        document.body.appendChild(app);
      }

      app.appendChild(container);
      app.appendChild(script);
    }
    catch (e) {
      if (args && typeof args.callback === 'function') {
        args.callback({
          message: 'Error in DeviceAssure QR Code setup',
          error: e.message
        });
      }
      sessionStorage.removeItem('deviceassure-qr-loading');
    }
  },

  /**
   * Returns a string or JSON object parsed from the redirect data.
   * @param data
   * @param _args
   * @returns {any|string}
   */
  parseRedirect: function (data, _args) {
    try {
      var encodedData = data;

      if (!encodedData) {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("response")) {
          encodedData = urlParams.get("response");
        }
      }

      var result;
      if (encodedData) {
        result = atob(encodedData);
      }

      if (result) {
        if (_args && _args.json) {
          return JSON.parse(result);
        }
        return result;
      }
    }
    catch (e) {
      console.error('Error parsing DeviceAssure QR Code redirect data', e);
    }
  }
};

module.exports = Qr;


/***/ }),

/***/ 565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* jshint strict: false */

var Common = __webpack_require__(782);


function getStorageGetDirectory() {
  return navigator && navigator.storage && navigator.storage.getDirectory;
}
/**
 * Collect Storage Properties
 * @param webJsProps
 * @private
 */
/* istanbul ignore next */
function detectStorageGetDirectory() {
  return Common.collectData(function () {
    if (typeof getStorageGetDirectory() !== 'undefined') {
      return true;
    }
  });
}

/**
 * Helper Method for collecting data for navigator.storage.estimate
 * @param estimate
 * @param property
 * @returns {{a: boolean, e: boolean}}
 */
/* istanbul ignore next */
function _collectNavigatorStorageEstimateProperty(estimate, property) {
  return Common.collectData(function () {

    if (estimate && typeof estimate[property] !== 'undefined') {
      return estimate[property];
    }

  });
}

/**
 * Method for collecting navigator.storage.estimate() data:
 * - quota
 * - usage
 * - usageDetails
 * @param args
 * @param _apiData
 */
/* istanbul ignore next */
function collectNavigatorStorageEstimate(args, _apiData) {

    if (navigator && navigator.storage && navigator.storage.estimate) {
      navigator.storage.estimate()
        .then(function (estimate) {
          _apiData.navigator_storage_quota = _collectNavigatorStorageEstimateProperty(estimate, 'quota');
          _apiData.navigator_storage_usage = _collectNavigatorStorageEstimateProperty(estimate, 'usage');
          _apiData.navigator_storage_usageDetails = _collectNavigatorStorageEstimateProperty(estimate, 'usageDetails');

          if (args && args.resolve) {
            args.resolve({
              navigator_storage_quota: _apiData.navigator_storage_quota,
              navigator_storage_usage: _apiData.navigator_storage_usage,
              navigator_storage_usageDetails: _apiData.navigator_storage_usageDetails
            });
          }
        })
        .catch(function() {
          if (args && args.resolve) {
            args.resolve();
          }
        });
    }
    else if (args && args.resolve) {
      args.resolve();
    }
}

/**
 * Method that detects whether or not it's possible to access `navigator.storage.getDirectory`
 * In Firefox private mode, it throws an error.
 * @param args
 * @param _apiData
 */
/* istanbul ignore next */
function canAccessStorageGetDirectory(args, _apiData) {

  if (!!getStorageGetDirectory()) {

    navigator.storage.getDirectory().then(function (data) {
        _apiData.navigator_storage_getDirectory_access = Common.collectData(function () {
          return data.kind + '_' + data.name;
        });
      })
      .catch(function (error) {
        _apiData.navigator_storage_getDirectory_access = Common.collectData(function () {
          return error.message;
        });
      })
      .finally(function () {
        if (args && args.resolve) {
          args.resolve(_apiData.navigator_storage_getDirectory_access);
        }
      });
  }
  else if (args && args.resolve) {
    args.resolve();
  }
}

var NavigatorStorageCollector = {
  collectNavigatorStorageEstimate: collectNavigatorStorageEstimate,
  collectNavigatorStorageEstimateProperty: _collectNavigatorStorageEstimateProperty,
  canAccessStorageGetDirectory: canAccessStorageGetDirectory,
  detectStorageGetDirectory: detectStorageGetDirectory,

  collect: function (webJsProps) {
    var dataCollectors = [
      { key: 'navigator_storage_getDirectory', collection: detectStorageGetDirectory }
    ];

    for (var i = 0; i < dataCollectors.length; i++) {
      var collector = dataCollectors[i];
      var allowCollect = collector.conditions || function () { return true; };
      var value = collector.collection(webJsProps);

      if (allowCollect(value)) {
        webJsProps[collector.key] = value;
      }
    }
  },
  getCollectionsForAsync: function () {
    return [
      { name: 'navigator_storage',                     collection: collectNavigatorStorageEstimate },
      { name: 'navigator_storage_getDirectory_access', collection: canAccessStorageGetDirectory    }
   ];
  }
};

module.exports = NavigatorStorageCollector;


/***/ }),

/***/ 566:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* jshint strict: false */

var Common = __webpack_require__(782);
var NavigatorCollector = __webpack_require__(92);
var NavigatorStorageCollector = __webpack_require__(565);
var Headers = __webpack_require__(65);
var HttpStatus = __webpack_require__(865);
var HttpRequestState = __webpack_require__(897);
var Requests = __webpack_require__(357);
var StringUtils = __webpack_require__(151);
var Qr = __webpack_require__(473);
var Clients = __webpack_require__(221);
var IMEI = __webpack_require__(718);
var CustomTags = __webpack_require__(803);
var WindowCollector = __webpack_require__(197);
var AutomationProperties = __webpack_require__(444);

module.exports = (function(libraryArgs, undefined) {

  var window = libraryArgs.window;
  var document = libraryArgs.document;
  var navigator = libraryArgs.navigator;

  var _globalOptions = {};

  var version = "1.1.0";

  var devicePropertiesAsString = "";
  var Library = {};
  var ApiClient = null;
  var DataCollector = null;
  var _DeviceAtlasCollector = null;
  var propertiesLoadComplete = false;
  var getPropertiesTimeoutInitialized = false;

  var isAppleDevice;
  var timeoutInitialized = false;
  var WAIT_ATTEMPTS = {
    SERVER_TO_SERVER: 0,
    AUDIO_REF: 0
  };
  var MAX_WAIT_ATTEMPTS = 10;
  var DEFAULT_TIME_TO_WAIT = 30;
  var loading = false;

  var VARIANT_PREFIX_BASE = 'DV-VARIANT';
  var VARIANT_PREFIX = VARIANT_PREFIX_BASE + '-' + version + StringUtils.__STRING_SEPARATOR;
  var VARIANT_ID = '';

  var MESSAGE_TYPES = {
    DA_MESSAGE: 'DA_MESSAGE',
    WAIT_AUDIO_REF: 'WAIT_AUDIO_REF',
    ON_LOAD: 'ON_LOAD'
  };

  var STORAGE_TYPE = {
    COOKIE: 'cookie',
    LOCAL_STORAGE: 'local-storage',
    NONE: 'none'
  };

  var DEFAULT_OPTIONS = {
    THIRTY_MINUTES_IN_MILLIS: 30 * 60 * 1000, // 30 Minutes
    TWENTY_FOUR_HOURS_IN_MILLIS: 24 * 60 * 60 * 1000, // 24 Hours
    CACHE_KEY: 'DV',
    CACHE_VALUE: '1'
  };

  var apiData = null;

  var currentUrl;
  var attempt = 0;
  // noinspection JSMismatchedCollectionQueryUpdate
  var prevErrors = [];
  var missingProperties = {};

  var PROMISE_TIMEOUT = 800;

  var _overriddenConfig = null;
  var _legacyMode = false;
  var _scriptAttributes = {};
  var _initialised = 0;
  var _metrics = {};

  /**
   * Checks if a specified task has exceeded the number of attempts to see if the value is present
   *
   * @param task
   * @returns {boolean}
   */
  var hasExceededAttempts = function (task) {
    return WAIT_ATTEMPTS[task] === undefined || WAIT_ATTEMPTS[task] === null || WAIT_ATTEMPTS[task] >= MAX_WAIT_ATTEMPTS;
  };

  /**
   * Returns whether library has been configured for serverToServer
   * @param options
   * @returns {*|{}|boolean}
   */
  var isServerToServer = function (options) {

    var dvOptions = options || _globalOptions || {};

    return (dvOptions && (dvOptions.s2s || dvOptions.serverToServer)) || undefined;
  };

  var isValidLicenceKey = function (options) {

    if (_isCustomUrlMode()) {
      return true;
    }

    if (!_validateLicence(options.licence, options)) {
      return false;
    }

    return options && options.licence && options.licence !== '<LICENCE_KEY>';
  };

  var getPayloadData = function (callback, payloadBuilder, _args) {
    var payloadData = payloadBuilder(_args);

    delete payloadData.info.dataCollectorKey;

    var configs = {
      onSuccess: !!callback,
      method: _args && _args.method,
      serverToServer: true
    };

    payloadData.info.serverToServer = true;

    _appendRequestConfigs(payloadData, configs);

    _completeSession();

    // call it if a callback function was provided and return else return payload
    if (callback != null && typeof callback === 'function') {
      callback(payloadData);
      return;
    }
    return payloadData;
  };

  /**
   * Adds an error element to the local buffer
   */
  var addError = function(errorObj) {
    prevErrors.push(errorObj);
  };

  var flushErrors = function() {
    prevErrors = [];
    loading = false;
    flushMissingProperties();
    resetAttempts();
  };

  var flushMissingProperties = function() {
    missingProperties = {};
  };

  var resetAttempts = function() {
    WAIT_ATTEMPTS = { SERVER_TO_SERVER: 0, AUDIO_REF: 0 };
  };

  var getApiUrls = function () {
    var apiUrls = (_globalOptions && _globalOptions.urls) || [];

    if (apiUrls.length > 0) {
      return apiUrls;
    }
    return _getDefaultOptions().urls;
  };

  var httpStatusToIgnored = function(status) {
    return HttpStatus.isIgnored(status);
  };

  /***
   * Method for making the API request to the DeviceAssure API. It uses an object to pass in the arguments.
   *
   * @param args.licence
   * @param args.onSuccess
   * @param args.onError
   * @param args.suppliedPayload
   * @param args.currentUrl
   * @param args.urls
   * @param args.method
   */
  var _doRequest = function(args) {

    var apiParams = args;
    if (!apiParams) {
      apiParams = {};
    }

    var licence = apiParams.licence;
    var onSuccess = apiParams.onSuccess;
    var onError = apiParams.onError;
    var suppliedPayload = apiParams.suppliedPayload;
    var currentUrl = apiParams.currentUrl;
    var urls = apiParams.urls;
    var method = apiParams && apiParams.method;

    var payload = suppliedPayload;

    if (!payload) {
      payload = buildPayload({ licence: licence });
    }

    var configs = {
      onSuccess: onSuccess,
      onError: onError,
      method: method,
    };

    if (_globalOptions) {
      configs.storageType = _globalOptions.sType;
      configs.storageExpiry = _globalOptions.sExpiry;
    }

    var _urls = urls || getApiUrls();
    currentUrl = !!currentUrl ? currentUrl : _urls[attempt];

    if (_overriddenConfig && _overriddenConfig.urls) {
      configs.urls = _urls;
    }

    _appendRequestConfigs(payload, configs);

    var dvLibraryType = 'web';

    var _onRequestError = function(e) {
      addError({hostUrl: currentUrl, httpStatus: 'N/A'});
      var response = {
        status: xhr.status,
        response: xhr.response
      };
      failover(licence, onSuccess, onError, suppliedPayload, response, urls);
    };

    var _onRequestReadyStateChange = function () {

      if (xhr.readyState !== HttpRequestState.DONE) {
        return;
      }

      var response = {
        status: xhr.status,
        response: xhr.response
      };

      // on success
      if (HttpStatus.isOk(xhr.status)) {
        _setTTL(response);

        attempt = 0;
        flushErrors();
        onSuccess(response);
        _completeSession();

        return response;
      }

      if (httpStatusToIgnored(xhr.status)) {

        attempt = 0;
        flushErrors();
        onError(response);
        _completeSession();

        return response;
      }

      // on error
      if (HttpStatus.isError(xhr.status)) {
        addError({ hostUrl: currentUrl, httpStatus: xhr.status });
        return failover(licence, onSuccess, onError, payload, response, urls);
      }
    };

    var _headers = Headers.getRequestHeaders({
      requestId: _getRequestId(),
      attempt: attempt + 1, // attempt is zero based index so add 1 to make it human friendly and logical
      version: payload.info.version,
      variants: payload.info.variants,
      libraryType: dvLibraryType
    });

    var xhr = Requests.init({
      url: currentUrl,
      headers: _headers,
      onReadyStateChange: _onRequestReadyStateChange,
      onError: _onRequestError
    });

    if (!xhr) {
      // did not get a valid XMLHttpRequest object
      if (onError) {
        onError({ message: 'Could not initiate HTTP request', error: true });
      }
      return;
    }

    loading = true;
    xhr.send(JSON.stringify(payload));
  };

  /**
   * Builds the telephony block of the payload.
   *
   * When an imei arg is passed in, then it will populate these fields too.
   *
   * The TAC is the first 8 digits of the IMEI.
   *
   * @param imei
   * @returns {{tac: null, imei: null }}
   * @private
   */
  var _buildTelephony = function(imei) {
    var telephony = {};

    var imeiValue = (imei && imei.replace(/\s/g, '')) || null;

    if (imeiValue) {
      telephony.imei = imeiValue;
      telephony.tac = imeiValue.length > 7 ? imeiValue.substring(0, 8) : imeiValue;
    }

    return telephony;
  };

  /**
   * Adds in the IMEI to the payload passed in or returns the new payload block
   * @param args - { licence, imei, payload }
   * @returns {{data: {memory: {}, sensors: [], build: {brand: *}, usb: {}, web: {webview: {jsProps: {}}, webviewUserAgent, systemUserAgent}, telephony: {isVoiceCapable: *, tac: null, imei: null, phoneCount: number}, display: {xDpi: *, heightPixels: number, yDpi: *, widthPixels: number}, cpu: {numCores: *, availableProcessors: *}, storage: {}, camera: [], gpu: {}}, info: {date: string, dataCollectorKey: *, serverToServer: boolean, source: string, version: string}}|*}
   * @private
   */
  var _buildIMEIPayload = function(args) {

    var licence = args && args.licence;
    var imei = args && args.imei;
    var payload = args && args.payload;

    if (!payload || Object.keys(payload).length === 0) {
      return buildPayload({ licence: licence, imei: imei });
    }

    if (!imei || imei.length < 1) {
      return payload;
    }

    var telephony = _buildTelephony(imei);

    if (payload && payload.data && !payload.data.telephony) {
      payload.data.telephony = telephony;
    }
    else if (payload && payload.data && payload.data.telephony) {
      payload.data.telephony.imei = telephony.imei;

      if (telephony.tac) {
        payload.data.telephony.tac = telephony.tac;
      }
    } else if (!payload.data) {
      payload.data = {
        telephony: telephony
      };
    }

    return payload;
  };

  /**
   * Returns whether the imei check is turned on or not.
   * @param params
   * @returns {boolean}
   */
  var isImeiEnabled = function(params) {

    var options = {};
    if (_legacyMode && !!_globalOptions) {
      options = _globalOptions;
    }
    else if (params) {
      options = params;
    }
    return !!options.imei || undefined;
  };

  /**
   * Builds the payload for the API request
   * @param args - { licence, imei }
   * @returns {{data: {memory: {}, sensors: [], build: {brand: *}, usb: {}, web: {webview: {jsProps: {}}, webviewUserAgent, systemUserAgent}, telephony: {isVoiceCapable: *, tac: null, imei: null, phoneCount: number}, display: {xDpi: *, heightPixels: number, yDpi: *, widthPixels: number}, cpu: {numCores: *, availableProcessors: *}, storage: {}, camera: [], gpu: {}}, info: {date: string, dataCollectorKey: *, serverToServer: boolean, source: string, version: string}}}
   */
  var buildPayload = function(args) {

    var licence = args && args.licence;
    var imei = args && args.imei;

    _metrics.payload = Date.now();

    var variants = _buildVariants();

    var userAgent = NavigatorCollector.getUserAgent(navigator);
    var payload = {
      info: {
        version: version,
        date: now(),
        source: 'Device Validation Web Client',
        serverToServer: false,

        requestId: _getRequestId(),
        variants: variants.ids,
        variantCount: variants.count,
      },
      data: {
        build: {
          brand: NavigatorCollector.getPlatform(navigator),
        },
        cpu: {
          availableProcessors: NavigatorCollector.getHardwareConcurrency(navigator),
          numCores: NavigatorCollector.getHardwareConcurrency(navigator)
        },
        display: {
          widthPixels:  window.screen.width,
          heightPixels: window.screen.height,
          xDpi: window.screen.deviceXDPI,
          yDpi: window.screen.deviceYDPI,
        },
        telephony: _buildTelephony(imei),
        web: {
          systemUserAgent: userAgent,
          webviewUserAgent: userAgent,
          webview: {
            jsProps: {},
            contexts: {
              o: null
            }
          }
        },
        gpu: {}
      }
    };

    if (_globalOptions && !!_globalOptions.tags) {
      if (!payload.meta) {
        payload.meta = {};
      }
      payload.meta.tags = _globalOptions.tags;
    }

    if (_legacyMode) {
      payload.info.legacy = true;
    }

    // Add errors carried over to the payload
    payload.errors = prevErrors || [];

    // for (var key in (missingProperties || {})) {
    //     var attempts = missingProperties[key];
    //
    //     if (attempts && attempts.length > 0) {
    //         payload.errors.push({ missingProperty: key, attempts: attempts });
    //     }
    // }

    _collectGpuProperties(payload.data.gpu);
    // use the concatenated String form of properties from the DeviceAtlas client-side
    // component until such time DeviceAtlas adds an easier way to get all the properties.

    var deviceAtlasProperties = getDeviceAtlasProperties();
    payload.data.web.webview.jsProps = getAdditionalWebProperties(deviceAtlasProperties);
    payload.data.web.webview.clientSide = getDevicePropsAsString();
    payload.data.web.webview.contexts.o = _collectOverrides();

    if (!_isCustomUrlMode()) {
      payload.info.dataCollectorKey = licence;
    }

    if (_metrics && _metrics.init && _metrics.payload) {
      payload.info.ttr = _metrics.payload - _metrics.init;
    }

    if (_metrics && _metrics.load && _metrics.payload) {
      payload.info.ttl = _metrics.payload - _metrics.load;
    }

    if (_metrics && _metrics.asyncFinished) {
      payload.info.ttca = _metrics.asyncFinished - _metrics.asyncStart;
    }

    return payload;
  };

  var failover = function(licence, onSuccess, onError, payload, response, urls, method) {

    if (isLastRetryAttempt(urls)) {
      attempt = 0;
      flushErrors();
      onError(response);
      _completeSession();
      return response;
    }

    attempt++;
    var url = (urls || getApiUrls())[attempt];

    var _args = {
      licence: licence,
      onSuccess: onSuccess,
      onError: onError,
      payload: payload,
      currentUrl: url,
      overrideLoading: true,
      urls: urls,
      method: method
    };

    getApiClient().validateDevice(_args);
  };

  /**
   * Collects the GPU properties from the browser.
   *
   * @param payload
   * @returns {{}|*}
   * @private
   */
  var _collectGpuProperties = function (payload) {
    var canvas = document.createElement('canvas');
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    var result = payload || {};
    if (gl) {
      if (gl.getParameter) {
        if (gl.VERSION && gl.getParameter(gl.VERSION)) {
          result.webGlVersion = gl.getParameter(gl.VERSION);
        }
        if (gl.VENDOR && gl.getParameter(gl.VENDOR)) {
          result.webGlVendor = gl.getParameter(gl.VENDOR);
        }
        if (gl.RENDERER && gl.getParameter(gl.RENDERER)) {
          result.webGlRenderer = gl.getParameter(gl.RENDERER);
        }
      }

      var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      if (debugInfo) {
        result.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
        result.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      }
    }
    return result;
  };

  var isLastRetryAttempt = function(urls) {
    var attemptURLS = urls || getApiUrls();
    return attempt === attemptURLS.length - 1;
  };

  var isPromiseSupported = function() {
    try {
      var _p = Promise || window.Promise;
      if (_p) {
        return typeof _p !== 'undefined';
      }
    }
    catch(e) {
      // ignore the error
    }
    return false;
  };

  var now = function() {
    var today = new Date();
    var pad = function (n) { return n < 10 ? '0' + n : n; };
    return today.getFullYear() + '-' +
      pad(today.getMonth() + 1) + '-' +
      pad(today.getDate()) + 'T' +
      pad(today.getHours()) + ':' +
      pad(today.getMinutes()) + ':' +
      pad(today.getSeconds());
  };
  /**
   * Returns the storage type for the configuration for Device Validation.
   *
   * Should return whatever is configured, or the default value:
   * - cookie
   * - local-storage
   *
   * @returns {string}
   * @private
   */
  var _getCurrentStorageType = function (overrideOptions) {

    var _options = {};

    if (_globalOptions && Object.keys(_globalOptions).length > 0) {
      _options = _globalOptions;
    }
    else if (overrideOptions) {

      var options = overrideOptions;

      if (typeof overrideOptions === 'string') {
        options = JSON.parse(overrideOptions);
      }

      if (Object.keys(options).length > 0) {
        _options = options;
      }
    }

    return _getStorageType(_options);
  };

  /**
   * Returns the storage type from the options passed in.
   * @param options
   * @returns {*|string}
   * @private
   */
  var _getStorageType = function (options) {

    var _options = options || {};

    var storage = StringUtils.trim((_options.sType || _options.storageType) || null, ' ');

    if ([STORAGE_TYPE.LOCAL_STORAGE, STORAGE_TYPE.COOKIE, STORAGE_TYPE.NONE].indexOf(storage) > -1) {
      return storage;
    }

    return _getDefaultOptions().sType;
  };

  /**
   * Returns the time to live for the cache. Value is in milliseconds.
   * @param options
   * @returns {number}
   * @private
   */
  var _getStorageExpiry = function (options) {

    var _options = (_globalOptions) || options || {};

    var expiry = (_options.sExpiry || _options.storageExpiry) || _getDefaultOptions().sExpiry;

    return expiry;
  };

  var _getStorageKey = function (options) {
    var _options = options || (_globalOptions) || {};
    var key = (_options && (_options.sKey || _options.storageKey)) || null || _getDefaultOptions().sKey;

    return key;
  };

  var localStorageSupport = function () {
    return (localStorage && !!localStorage.getItem) || false;
  };

  /**
   * Gets the cached Value for the specified arguments
   *
   * @param args
   * @returns {*|null}
   * @private
   */
  var _getTTL = function (args) {
    var type = _getCurrentStorageType(args.options);

    if (type === STORAGE_TYPE.NONE) {
      return null;
    }
    var _options = { name: args.name, options: args.options };

    var value = null;
    if (type === STORAGE_TYPE.COOKIE) {
      value = _getCookie(_options);
    }
    else if (type === STORAGE_TYPE.LOCAL_STORAGE) {
      value = _getLocalStorage(_options);
    }

    if (value && typeof value === 'string') {
      value = JSON.parse(value);
    }

    return value;
  };

  var _getCacheValue = function (options) {
    return _getTTL({ name: _getStorageKey(options), options: options });
  };

  var _getCookie = function(args) {

    if (!document.cookie) {
      return null;
    }

    if (_getCurrentStorageType(args.options) === STORAGE_TYPE.NONE) {
      return null;
    }

    var cookies = document.cookie.split(';');

    var name = args.name;
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var cookieParts = cookie.split('=');

      if (cookieParts.length === 2 && !!cookieParts[0] && cookieParts[0].trim() === name) {
        return cookieParts[1];
      }
    }
    return null;
  };

  /**
   * Returns the DV storage value
   *
   * When the item is expired or invalid, a value of '' is returned
   *
   * Otherwise, the value is returned.
   *
   * @param args ({ name, options })
   * @returns {string | null}
   * @private
   */
  var _getLocalStorage = function (args) {
    if (!localStorageSupport()) {
      return null;
    }

    if (_getCurrentStorageType(args.options) === STORAGE_TYPE.NONE) {
      return null;
    }

    var name = args.name;
    var cachedProperties = window.localStorage.getItem(name);
    if (!cachedProperties) {
      return null;
    }

    var item = '';

    try {
      item = JSON.parse(cachedProperties);
    } catch(e) {
      localStorage.removeItem(name);
      return null;
    }
    if ((new Date()).getTime() > item.expiry) {
      localStorage.removeItem(name);
      return null;
    }

    var value = null;

    if (item && item.value !== undefined || item.value !== null) {
      value = item.value;
    }
    return value;
  };

  var _setTTL = function (response, options) {
    var type = _getCurrentStorageType(options);

    if (type === STORAGE_TYPE.COOKIE) {
      _setCookie({ options: response, data: response});
    }
    else if (type === STORAGE_TYPE.LOCAL_STORAGE) {
      _setLocalStorage({ options: response, data: response});
    }
  };

  var _setCookie = function(args) {

    var options = args.options;
    var value = args.data;

    if (_getCurrentStorageType(options) === STORAGE_TYPE.NONE) {
      return;
    }

    var expiryDate = new Date();
    var cacheKey = _getStorageKey();

    var expiry = _getStorageExpiry(options);
    if (expiry === undefined || expiry === null) {
      expiry = DEFAULT_OPTIONS.THIRTY_MINUTES_IN_MILLIS;
    }

    expiryDate.setTime(expiryDate.getTime() + expiry);

    var valueToStore = value || { value: DEFAULT_OPTIONS.CACHE_VALUE };
    if (typeof valueToStore === 'object') {
      valueToStore = JSON.stringify(valueToStore);
    }

    if (document.cookie.indexOf(cacheKey + '=' + valueToStore) === -1) {
      document.cookie = cacheKey + '=' + valueToStore + ';expires=' + expiryDate.toUTCString() + ';path=/';
    }

    localStorage.removeItem(cacheKey);
  };

  var _setLocalStorage = function (args) {

    var options = args.options;
    var value = args.data;

    if (_getCurrentStorageType(options) === STORAGE_TYPE.NONE) {
      return;
    }

    var valueToStore = value || { value: DEFAULT_OPTIONS.CACHE_VALUE };
    if (typeof valueToStore === 'object') {
      valueToStore = JSON.stringify(valueToStore);
    }

    var cacheKey = _getStorageKey();

    var expiry = _getStorageExpiry(options);
    if (expiry === undefined || expiry === null) {
      expiry = DEFAULT_OPTIONS.THIRTY_MINUTES_IN_MILLIS;
    }

    var item = { value: valueToStore, expiry: (new Date().getTime() + expiry) };
    window.localStorage.setItem(cacheKey, JSON.stringify(item));

    var defaultCacheValue = JSON.stringify({ value: DEFAULT_OPTIONS.CACHE_VALUE });
    var expiryDate = new Date(0).toUTCString();

    document.cookie = cacheKey + '=' + defaultCacheValue + ';expires=' + expiryDate + ';path=/';
  };

  /**
   * Default options for the DeviceAssure Library
   * @returns {
   *   licence: string,
   *   method: string,
   *   s2s: boolean,
   *   imei: IMEI: string (boolean in legacy setup),
   *   customUrlMode: boolean,
   *   onError: function,
   *   onSuccess: function,
   *   urls: string[],
   *   sType: string,
   *   sKey: string,
   *   sExpiry: string
   * }
   */
  function _getDefaultOptions() {
    return {
      licence: undefined,
      method: undefined,
      s2s: false,
      imei: null,
      customUrlMode: false,
      onSuccess: undefined,
      onError: undefined,
      urls: ["https://api1.devicevalidation.io/check","https://api2.devicevalidation.io/check","https://api3.devicevalidation.io/check"],
      tags: null,
      sExpiry: DEFAULT_OPTIONS.THIRTY_MINUTES_IN_MILLIS,
      sKey: DEFAULT_OPTIONS.CACHE_KEY,
      sType: STORAGE_TYPE.LOCAL_STORAGE // can also be STORAGE_TYPE.COOKIE or STORAGE_TYPE.NONE
    };
  }

  /**
   * The last stop after the DeviceAtlasCollector onPropertiesUpdate is called.
   *
   * @param options
   */
  var runCheckAuto = function(options) {
    propertiesLoadComplete = true;

    var dvOptions = options;
    if (!dvOptions) {
      dvOptions = {};
    }

    var _args = {
      s2s: isServerToServer(dvOptions),
      licence: dvOptions.licence,
      onSuccess: dvOptions.onSuccess,
      onError: dvOptions.onError,
      storageType: _getCurrentStorageType(dvOptions),
    };

    if (dvOptions && dvOptions.hasOwnProperty('imei')) {
      _args.imei = dvOptions.imei;
    }

    if (dvOptions && dvOptions.method) {
      _args.method = dvOptions.method;
    }

    var serverToServer = isServerToServer(_args);

    if (serverToServer && _args.onSuccess) {

      if (dvOptions.hasOwnProperty('imei')) {
        getApiClient().getDevicePropertiesWithIMEI(_args.imei, _args);
      }
      else {
        getApiClient().getDeviceProperties({
          callback: _args.onSuccess,
          method: _args.method
        });
      }
    }
    else if (!serverToServer && isValidLicenceKey(_args)) {
      if (!dvOptions.hasOwnProperty('imei')) {
        getApiClient().validateDevice(_args);
      }
      else if (!_legacyMode) {
        getApiClient().validateDeviceWithIMEI(_args.imei, _args);
      }
    }
  };

  // Adding additional properties requested from DV-1324
  var getAdditionalWebProperties = function(deviceAtlasProperties) {
    var webJsProps = {};

    // Copy properties from deviceAtlasProperties
    var _i, prop;
    if (deviceAtlasProperties) {
      var deviceAtlasPropertyKeys = Object.keys(deviceAtlasProperties);
      for (_i = 0; _i < deviceAtlasPropertyKeys.length; _i++) {
        webJsProps[deviceAtlasPropertyKeys[_i]] = deviceAtlasProperties[deviceAtlasPropertyKeys[_i]];
      }
    }

    // Add navigator properties
    var props = ['deviceMemory', 'oscpu', 'platform', 'productSub', 'webdriver'];
    for (_i = 0; _i < props.length; _i++) {
      prop = props[_i];
      if (typeof navigator[prop] !== 'undefined') {
        webJsProps['navigator.' + prop] = navigator[prop];
      }
    }

    // Add connection property
    if ('connection' in navigator && navigator.connection.saveData) {
      webJsProps["navigator.saveData"] = navigator.connection.saveData;
    }

    // Add screen properties
    var screenProps = ['width', 'height', 'availWidth', 'availHeight'];
    for (_i = 0; _i < screenProps.length; _i++) {
      prop = screenProps[_i];
      if (typeof window.screen[prop] !== 'undefined') {
        webJsProps['screen.' + prop] = window.screen[prop];
      }
    }

    // Add ApplePaySession property
    if (typeof window.ApplePaySession !== 'undefined') {
      webJsProps.applePaySession = !!window.ApplePaySession;
    }

    webJsProps['eval.length'] = eval.toString().length;
    webJsProps.hasVibrationApi = typeof navigator.vibrate === 'function' ? !!navigator.vibrate : false;
    webJsProps.promises = isPromiseSupported();

    initIsAppleDevice();
    webJsProps = detectPropertiesForiOS(webJsProps);

    _collectOrientationType(webJsProps);
    _collectDimensions(webJsProps);
    _collectCrypto(webJsProps);
    _collectSecureContext(webJsProps);
    _collectLocationData(webJsProps);
    _collectScreenAvailTop(webJsProps);
    _collectDocumentReadyState(webJsProps);

    _collectBrowserErrorID(webJsProps);
    _collectHasIndexedDB(webJsProps);
    _collectJsHeapSizeLimit(webJsProps);
    _collectLocalStoragePersistence(webJsProps);

    WindowCollector.collect(webJsProps);
    NavigatorCollector.collect(webJsProps);
    NavigatorStorageCollector.collect(webJsProps);
    AutomationProperties.collect(webJsProps);

    _detectWebApiPermissions();

    return _addApiData(webJsProps);
  };

  /**
   * Returns the status of the document, it can be one of the following:
   * - loading
   * - interactive
   * - complete
   *
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
   *
   * @param webJsProps
   * @returns {*}
   * @private
   */
  var _collectDocumentReadyState = function (webJsProps) {

    webJsProps.document_readyState = _collectData(function () {
      if (document && document.readyState) {
        return document.readyState;
      }
    });

    return webJsProps;
  };

  /**
   * Collects whether the crypto object is available in the window object
   * @param webJsProps
   * @private
   */
  var _collectCrypto = function (webJsProps) {
    webJsProps.window_crypto = _collectData(function () {
      return _hasCrypto();
    });
  };

  /**
   * Adds the api data collected to the webJsProps passed in.
   */
  var _addApiData = function (webJsProps) {
    if (!apiData) {
      return webJsProps || {};
    }

    var jsApiKeys = Object.keys(apiData);
    for (var i = 0; i < jsApiKeys.length; i++) {
      var api = jsApiKeys[i];

      if (!!api) {
        webJsProps[api] = apiData[api];
      }
    }

    return webJsProps || {};
  };


  /**
   * Returns whether the plugins key is present in the navigator object
   *
   * @returns {boolean}
   */
  var _isNavigatorPluginsAvailable = function () {
    return 'plugins' in navigator || typeof navigator.plugins !== 'undefined';
  };

  /**
   * Collects the dimensions for the window object.
   * When the outerWidth and outerHeight are 0, then it could be a sign of headless
   * @param webJsProps
   * @returns {*}
   * @private
   */
  var _collectDimensions = function (webJsProps) {
    var keys = ['outerWidth', 'outerHeight', 'innerWidth', 'innerHeight'];

    for (var i = 0; i < keys.length; i++) {
      var _key = keys[i];
      var _value = typeof window[_key] !== 'undefined' ? window[_key] : null;
      webJsProps['window_' + _key] = { a: _key in window, v: _value };
    }

    if (webJsProps.window_outerWidth && webJsProps.window_outerWidth.a && webJsProps.window_outerHeight && webJsProps.window_outerHeight.a) {
      webJsProps.window_hidden =  webJsProps.window_outerWidth.v === 0 && webJsProps.window_outerHeight.v === 0;
    }

    return webJsProps;
  };

  /**
   * Tests the behaviour of the localStorage object in the window object.
   * @param webJsProps
   * @private
   */
  var _collectLocalStoragePersistence = function (webJsProps) {

    if (!window || !window.localStorage) {
      return;
    }

    webJsProps.localStorage = _collectData(function () {
      try {
        window.localStorage.setItem('DeviceAssure', '1');
        window.localStorage.removeItem('DeviceAssure');
      }
      catch (e) {
        return 'error';
      }
      return 'available';
    });
  };


  /**
   * Method to test the collection of the indexedDB upgrade needed
   *
   * @param event
   * @param db
   * @param args
   * @param dbName
   * @param _apiData
   * @private
   */
  var _collectIndexDBUpgradeNeeded = function (event, db, args, dbName, _apiData) {
    var _value = null;

    var _db = (event && event.target && event.target.result) || null;

    try {
      _db.createObjectStore(dbName, { autoIncrement: true }).put(new Blob());
    }
    catch (error) {
      _value = error;
      if (error && error.message) {
        _value = error.message;
      }
      else if (typeof _value === 'string' && _value.indexOf('BlobURLs are not yet supported') > -1) {
        _value = 'BlobURLs are not yet supported';
      }
    }
    finally {
      if (_db && _db.close) {
        _db.close();
      }
      if (db && db.close) {
        db.close();
      }
      // Remove our test database
      if (indexedDB && indexedDB.deleteDatabase && dbName) {
        indexedDB.deleteDatabase(dbName);
      }
    }

    if (_value) {
      var _result = _collectData(function () { return _value; });
      _result.e = true;
      _apiData.indexedDB_persistence = _result;
    }

    if (args && args.resolve) {
      args.resolve(_apiData.indexedDB_persistence);
    }
  };

  /**
   * Determines if writing to the indexedDB is possible. Used to help identify incognito mode in safari.
   * @param args - { resolve, reject }
   * @param _apiData - {}
   * @private
   */
  var _collectIndexedDBPersistence = function (args, _apiData) {

    if (!window.indexedDB) {
      _apiData.indexedDB_persistence = { a: false, e: false  };
      if (args && args.resolve) {
        args.resolve(_apiData.indexedDB_persistence);
      }
      return;
    }

    try {
      var dbName = 'DeviceAssure_' + Date.now();
      var db = window.indexedDB.open(dbName);

      db.onupgradeneeded = function (event) {
        _collectIndexDBUpgradeNeeded(event, db, args, dbName, _apiData);
      };
    }
    catch (e) {
      _apiData.indexedDB_persistence = { a: true, e: true };

      if (args && args.resolve) {
        args.resolve(_apiData.indexedDB_persistence);
      }
    }
  };


  /**
   * This is used as a way to detect chrome incognito mode from version 50 to 75.
   *
   * @param args - { resolve, reject }
   * @param _apiData - { }
   * @private
   */
  var _collectWebkitRequestFileSystem = function (args, _apiData) {

    var callback = function (result) {

      _apiData.webkitRequestFileSystem = _collectData(function () { return result; });
      _apiData.webkitRequestFileSystem.e = 'error' === result;

      if (args && args.resolve) {
        args.resolve(_apiData.webkitRequestFileSystem);
      }
    };

    if (window.webkitRequestFileSystem) {
      window.webkitRequestFileSystem(0, 1, function () { callback('success'); }, function () { callback('error'); });
    }
    else if (args && args.resolve) {
      args.resolve();
    }
  };

  /**
   * Collect the client hints separately to device atlas to see if there's any discrepancy between
   * the two. At the time of writing, the default values for the client hints are:
   * - brands
   * - mobile
   * - platform
   *
   * @private
   */
  var _collectMinimumClientHints = function (args, _apiData) {

    if (!navigator || !navigator.userAgentData || !navigator.userAgentData.getHighEntropyValues) {

      if (args && args.resolve) {
        args.resolve();
      }
      return;
    }

    // Requesting empty client hints to see if there's any discrepancy between the DA one.
    navigator.userAgentData.getHighEntropyValues([])
      .then(function (values) {

        _apiData.clientHintsMinimum = { a: true, e: false, v: values };

        if (args && args.resolve) {
          args.resolve(_apiData.clientHintsMinimum);
        }
      })
      .catch(function () {

        if (!_apiData.clientHintsMinimum) {
          _apiData.clientHintsMinimum = {};
        }
        _apiData.clientHintsMinimum.a = true;
        _apiData.clientHintsMinimum.e = true;

        if (args && args.resolve) {
          args.resolve(_apiData.clientHintsMinimum);
        }
      });
  };


  /**
   * Adds sensor object to the jsProps passed in.
   */
  var _detectWebApiPermissions = function () {

    if (!apiData) {
      apiData = {};
    }

    // DeviceMotion and DeviceOrientation events should be true in iOS
    // IdleDetector events should be true in chrome [desktop]
    var apis = [
      'DeviceMotionEvent',
      'DeviceOrientationEvent',
      'DeviceMotionEventAcceleration',
      'DeviceMotionEventRotationRate',

      'IdleDetector',

      'DragEvent',
      'GestureEvent' // Looks to be Apple only
    ];

    for (var i = 0; i < apis.length; i++) {
      var apiName = apis[i];

      if (!apiName){
        continue;
      }

      apiData[apiName] = {
        available: !!window[apiName],
        requiresPermission: _apiRequiresPermissions(apiName)
      };
    }

    return apiData;
  };

  /**
   * Records if the specified api requires permissions to run a sensor.
   */
  var _apiRequiresPermissions = function (apiName) {
    if (!apiName) {
      return false;
    }

    var requestPermission = (!!window[apiName] && window[apiName].requestPermission) || null;

    return typeof requestPermission === 'function';
  };

  var _collectData = function (dataFunction, args) {
    return Common.collectData(dataFunction, args);
  };

  /**
   * Attempts to collect the orientation type
   * @param webJsProps
   */
  var _collectOrientationType = function (webJsProps) {
    var orientation_data = _collectData(function () {
      return window.screen.orientation.type;
    });

    webJsProps.screen_orientation_type = orientation_data;
  };

  /**
   * Returns whether sessionStorage is available or not.
   *
   * @returns {boolean}
   * @private
   */
  var _hasSessionStorage = function () {
    return 'sessionStorage' in window && window.sessionStorage !== null;
  };

  /**
   * Returns whether crypto is available or not.
   *
   * @returns {boolean}
   * @private
   */
  var _hasCrypto = function () {

    if ('crypto' in window && !!window.crypto) {
      return !!window.crypto.randomUUID && !!window.crypto.getRandomValues;
    }

    return false;
  };

  /**
   * Collects the jsHeapSizeLimit from the performance object. Used in detection of chrome incognito mode.
   *
   * @param webJsProps
   * @private
   */
  var _collectJsHeapSizeLimit = function (webJsProps) {
    if (!window.performance || !window.performance.memory || typeof window.performance.memory.jsHeapSizeLimit === 'undefined') {
      return;
    }

    webJsProps.jsHeapSizeLimit = _collectData(function () {
      if (window.performance && window.performance.memory) {
        return window.performance.memory.jsHeapSizeLimit;
      }
    });
  };

  /***
   *
   * Each Browser engine returns a different value for this function.
   *
   * Chrome: 51
   * Firefox: 25
   * Safari: 44
   * PhantomJS: 43
   *
   * */
  var _getFixedEngineID = function () {
    var _engineID = 0;

    try {
      (-1).toFixed(-1);
    } catch (e) {
      _engineID = e.message.length;
    }

    return _engineID;
  };

  /**
   * Collects what type of browser it is from the length of the default error message.
   * @param webJsProps
   * @private
   */
  var _collectBrowserErrorID = function (webJsProps) {
    webJsProps.browserErrorID = _collectData(function () { return _getFixedEngineID(); });
  };

  var _collectHasIndexedDB = function (webJsProps) {
    webJsProps.indexedDB = _collectData(function () {
      if (typeof window.indexedDB !== 'undefined') {
        return true;
      }
    });
  };


  /**
   * Collects the secure context data
   * @param {*} webJsProps
   */
  var _collectSecureContext = function (webJsProps) {

    var secureContextData = _collectData(function () {
      return window.isSecureContext;
    });

    webJsProps['window_isSecureContext'] = secureContextData;
  };


  var _collectLocationData = function (webJsProps) {

    var locationOrigin = _collectData(function () {
      return window.location.origin;
    });

    webJsProps['window_location_origin'] = locationOrigin;

    var locationProtocol = _collectData(function () {
      return window.location.protocol;
    });

    webJsProps['window_location_protocol'] = locationProtocol;

    var locationHost   = _collectData(function () {
      return window.location.host;
    });

    webJsProps['window_location_host'] = locationHost;
  };

  /**
   * Attempts to collect the screen.availTop
   * @param webJsProps
   */
  var _collectScreenAvailTop = function (webJsProps) {
    var availTop = _collectData(function () {
      return window.screen.availTop;
    });

    webJsProps.screen_availTop = availTop;
  };

  var detectPropertiesForiOS = function (webJsProps) {

    var jsProps = webJsProps;
    if (!jsProps) {
      jsProps = {};
    }

    // iPhone simulator does not have these properties yet.
    jsProps['document.pictureInPictureElement'] = document.pictureInPictureElement ? true : null;


    var pictureInPictureEnabled = false;
    if (document.pictureInPictureEnabled || document.pictureInPictureEnabled === false) {
      pictureInPictureEnabled = document.pictureInPictureEnabled;
    }

    jsProps['document.pictureInPictureEnabled'] = pictureInPictureEnabled;

    // iPads and Browsers have these properties.
    jsProps['document.webkitCancelFullScreen'] = document.webkitCancelFullScreen ? true : null;
    jsProps['document.webkitExitFullScreen'] = document.webkitExitFullScreen ? true : null;
    jsProps['document.webkitCurrentFullScreenElement'] = document.webkitCurrentFullScreenElement ? true : null;
    jsProps['document.webkitFullscreenElement'] = document.webkitFullscreenElement ? true : null;

    var webkitFullscreenEnabled = false;
    if (document.webkitFullscreenEnabled || document.webkitFullscreenEnabled === false) {
      webkitFullscreenEnabled = document.webkitFullscreenEnabled;
    }
    jsProps['document.webkitFullscreenEnabled'] = webkitFullscreenEnabled;

    var webkitFullScreenKeyboardInputAllowed = false;
    if (document.webkitFullScreenKeyboardInputAllowed || document.webkitFullScreenKeyboardInputAllowed === false) {
      webkitFullScreenKeyboardInputAllowed = document.webkitFullScreenKeyboardInputAllowed;
    }
    jsProps['document.webkitFullScreenKeyboardInputAllowed'] = webkitFullScreenKeyboardInputAllowed;

    // iOS property
    jsProps['navigator.standalone'] = typeof navigator.standalone !== 'undefined' ? navigator.standalone : null;

    return jsProps;
  };

  var initIsAppleDevice = function() {
    if (typeof isAppleDevice === 'undefined') {
      isAppleDevice = NavigatorCollector.isAppleUserAgent(navigator);
    }
  };

  var getDevicePropsAsString = function() {

    devicePropertiesAsString = (_getDeviceAtlasCollector().getPropertiesAsString && _getDeviceAtlasCollector().getPropertiesAsString()) || '';

    if (typeof devicePropertiesAsString !== 'string') {
      devicePropertiesAsString = '';
    }

    return devicePropertiesAsString;
  };

  var getDeviceAtlasProperties = function () {
    var properties = (_getDeviceAtlasCollector().getProperties && _getDeviceAtlasCollector().getProperties()) || {};

    if (typeof properties !== 'object') {
      properties = {};
    }

    return properties;
  };


  /**
   * Cleans the existing entries for the variant ids in the session storage. It will not remove other library versions
   * that are present in the session storage.
   *
   * The result is a single entry in session storage for the variant id for this library version.
   *
   * @returns {number|string}
   * @private
   */
  function _generateVariantId() {
    var id = _uuidv4();

    if (!id) {
      return Date.now();
    }

    if (!_hasSessionStorage()) {
      return id;
    }

    var sessionKeys = Object.keys(window.sessionStorage);
    for (var i = 0; i < sessionKeys.length; i++) {
      var key = sessionKeys[i];
      if (key.indexOf(_getVariantPrefix()) > -1) {
        window.sessionStorage.removeItem(key);
      }
    }

    var entry = {
      completed: false,
      date: Date.now()
    };

    window.sessionStorage.setItem(_getVariantPrefix() + id, JSON.stringify(entry));

    return id;
  }

  /**
   * Returns the current request id.
   * @returns {*|string|number}
   * @private
   */
  function _getRequestId() {

    if (_globalOptions.requestId) {
      return _globalOptions.requestId;
    }

    _globalOptions.requestId = _uuidv4();

    if (_globalOptions.requestId) {
      _globalOptions.requestId = _globalOptions.requestId + '.' + Date.now();
    }
    else {
      _globalOptions.requestId = Date.now();
    }

    return _globalOptions.requestId;
  }

  /**
   * Completes the session in the sessionStorage and then attempts to clean the rest of the variants
   * in the session storage.
   *
   * @private
   */
  function _completeSession() {

    if (!_hasSessionStorage()) {
      return;
    }

    if (_globalOptions && _globalOptions.requestId) {
      delete _globalOptions.requestId;
    }

    try {
      var key = _getVariantId();
      var entry = window.sessionStorage.getItem(key);

      if (entry) {
        var obj = JSON.parse(entry);
        obj.completed = true;
        window.sessionStorage.setItem(key, JSON.stringify(obj));
      }
    }
    catch (e) {
      window.sessionStorage.setItem(_getVariantId(), JSON.stringify({ completed: true, error: true, date: Date.now() }));
    }
    _purgeVariants();
  }

  /**
   * Returns the variant id for this library version.
   *
   * @returns {string}
   * @private
   */
  function _getVariantId() {
    return _getVariantPrefix() + VARIANT_ID;
  }

  /**
   * Returns the variant prefix for this library version.
   * @returns {string}
   * @private
   */
  function _getVariantPrefix() {
    return VARIANT_PREFIX;
  }

  /**
   * Cleans all the variants if they are present in the session storage and have a value of 'completed': true.
   *
   * @private
   */
  function _purgeVariants() {

    VARIANT_ID = '';

    if (!_hasSessionStorage()) {
      return;
    }

    var libraryKeys = [];
    var allCompleted = true;
    var sessionKeys = Object.keys(window.sessionStorage);

    var i;
    for (i = 0; i < sessionKeys.length; i++) {
      var key = sessionKeys[i];

      if (key.indexOf(VARIANT_PREFIX_BASE) > -1) {
        libraryKeys.push(key);

        var entry = window.sessionStorage.getItem(key);
        if (entry) {
          var obj = JSON.parse(entry);
          if (!obj.completed) {
            allCompleted = false;
            break;
          }
        }
      }
    }

    if (allCompleted) {
      for (i = 0; i < libraryKeys.length; i++) {
        window.sessionStorage.removeItem(libraryKeys[i]);
      }
    }
  }


  /**
   * Builds the variants block of the payload.
   * The ids are a concatenated string of the variant ids.
   * The count is the number of variants in the string.
   *
   * @returns {{count: number, ids: string}}
   * @private
   */
  var _buildVariants = function () {
    var ids = '';
    var count = 0;

    if ('sessionStorage' in window) {

      var sessionKeys = Object.keys(window.sessionStorage);

      for (var i = 0; i < sessionKeys.length; i++) {

        var key = sessionKeys[i];
        if (key.indexOf(VARIANT_PREFIX_BASE) > -1) {

          var parts = key.split(StringUtils.__STRING_SEPARATOR);

          if (parts.length > 1) {
            var variantId = parts[parts.length - 1];
            ids = ids + variantId + StringUtils.__STRING_SEPARATOR;
            count++;
          }
        }
      }

      // Trim the last two '__'
      if (ids.length > 2) {
        ids = ids.substring(0, ids.length - 2);
      }
    }

    return {
      ids: ids,
      count: count
    };
  };


  /**
   * Crypto is only available in secure contexts, so we need to generate a UUIDv4 if it is not available.
   *
   * Found here: https://stackoverflow.com/a/8809472
   *
   * @returns {string}
   * @private
   */
  function _uuidv4() {

    if (_hasCrypto()) {
      return window.crypto.randomUUID();
    }

    // Fallback for when the crypto object is not available
    try {
      var d = new Date().getTime();
      var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;
        if(d > 0){
          r = (d + r)%16 | 0;
          d = Math.floor(d/16);
        } else {
          r = (d2 + r)%16 | 0;
          d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }
    catch (e) {}

    return '';
  }


  function _createMissingPropertyAttempt(attempt, type) {

    if (!type) {
      type = MESSAGE_TYPES.WAIT_AUDIO_REF;
    }

    return {
      isFirst: attempt === 1,
      date: Date.now(),
      attempt: attempt,
      present: false,
      type: type
    };
  }

  /**
   * Function is triggered onLoad of the DeviceAtlas library and when we detect any changes.
   * @param properties
   * @param propertiesAsString
   */
  function _onPropertiesUpdate(properties, propertiesAsString) {
    _initialised++;

    getDataCollector().collect(MESSAGE_TYPES.DA_MESSAGE, true);
  }

  /**
   * Checks whether the daProps string passed in has the audioRef in it or not.
   * @returns {boolean}
   * @private
   */
  function _hasAudioRef() {
    var daProps = getDeviceAtlasProperties();

    var audioRef = (daProps && daProps.audioRef) || null;

    // common scenarios
    if ([null, 'null', '', 0].indexOf(audioRef) > -1) {
      return false;
    }

    return !!((audioRef + '').trim()); // check if present
  }

  /***
   * To tackle a situation where it is an Apple device but never gives back the audioRef then
   * wait for 1 second and continue with execution of the script.
   *
   * @param timeToWait
   * @param doRequest
   * @param type
   */
  function _asyncCheckForApple(timeToWait, doRequest, type) {

    if (type && type !== MESSAGE_TYPES.DA_MESSAGE && (!isAppleDevice || timeoutInitialized || hasExceededAttempts('AUDIO_REF'))) {
      return;
    }

    timeoutInitialized = true;
    WAIT_ATTEMPTS.AUDIO_REF++;

    if (!timeToWait || timeToWait < 1) {
      timeToWait = DEFAULT_TIME_TO_WAIT;
    }

    var asyncCheck = function() {
      timeoutInitialized = false;

      if (!isAppleDevice) {
        return;
      }

      var audioRefProperties = !!missingProperties.audioRef ? missingProperties.audioRef : [];
      var attempt = _createMissingPropertyAttempt(audioRefProperties.length + 1, MESSAGE_TYPES.WAIT_AUDIO_REF);

      // Flag that our audioRef was missing or present for this attempt.
      attempt.present = _hasAudioRef();
      audioRefProperties.push(attempt);

      missingProperties.audioRef = audioRefProperties;

      var exceeded = hasExceededAttempts('AUDIO_REF');

      // Attempt to find the audioRef at most 10 times, total time to take should be between 100ms to 300ms
      if (!attempt.present && !exceeded) {
        _asyncCheckForApple(timeToWait, doRequest, MESSAGE_TYPES.WAIT_AUDIO_REF);
      }
      else if (doRequest || exceeded) {
        runCheckAuto(_globalOptions, type);
      }
    };

    setTimeout(asyncCheck, timeToWait);
  }

  /**
   * Detect if WebGLRenderingContext has been overridden
   *
   * @returns Object
   * @private
   */
  function _detectWebGlOverrides() {

    var _callback = function () {
      if (!WebGLRenderingContext || !WebGLRenderingContext.prototype || !Object || !Object.getOwnPropertyDescriptor) {
        return undefined;
      }

      var descriptor = Object.getOwnPropertyDescriptor(WebGLRenderingContext.prototype, 'getParameter');

      return _buildCanvasOverrideResult(descriptor, [], ['[native code]']);
    };

    return _collectData(_callback);
  }

  function _detectHTMLCanvasOverridesGetContext() {
    var _callback = function () {
      if (!HTMLCanvasElement || !HTMLCanvasElement.prototype || !Object || !Object.getOwnPropertyDescriptor) {
        return undefined;
      }

      var descriptor = Object.getOwnPropertyDescriptor(HTMLCanvasElement.prototype, 'getContext');

      return _buildCanvasOverrideResult(descriptor, [], ['[native code]']);
    };

    return _collectData(_callback);
  }


  /**
   * Builds the result of the HTMLCanvasElement overrides.
   *
   * Broken out so it can be unit tested and gain coverage. It's never overridden in test code.
   *
   * @param descriptor
   * @param ignored - properties to not include
   * @param ignoredValues - values to not include
   * @returns {{}}
   * @private
   */
  function _buildCanvasOverrideResult(descriptor, ignored, ignoredValues) {

    var _result;
    if (descriptor) {
      _result = {};
      if (!ignored || ignored.indexOf('enumerable') === -1) {
        _result.enumerable = descriptor.enumerable;
      }

      if (!ignored || ignored.indexOf('writable') === -1) {
        _result.writable = descriptor.writable;
      }

      if (!ignored || ignored.indexOf('configurable') === -1) {
        _result.configurable = descriptor.configurable;
      }

      if ((!ignored || ignored.indexOf('get') === -1) && typeof descriptor.get !== 'undefined' && descriptor.get.toString().indexOf('[native code]') < 0) {
        _result.getter = descriptor.get.toString();
      }

      if ((!ignored || ignored.indexOf('set') === -1) && typeof descriptor.set !== 'undefined' && descriptor.set.toString().indexOf('[native code]') < 0) {
        _result.setter = descriptor.set.toString();
      }

      if ((!ignored || ignored.indexOf('value') === -1) && typeof descriptor.value !== 'undefined') {
        var _value;

        if (typeof descriptor.value === 'object') {
          _value = JSON.stringify(descriptor.value);
        } else {
          _value = descriptor.value.toString();
        }
        _result.value = _value;
      }
    }

    return _result;
  }

  /**
   * Collects the options the library was run with.
   *
   * @param payload
   * @param options
   * @private
   */
  function _appendRequestConfigs(payload, options) {
    if (!payload || !payload.data || !payload.data.web || !payload.data.web.webview || !payload.data.web.webview.jsProps) {
      return;
    }

    var configs = _collectData(function (_args) {

      if (!_args) {
        return;
      }

      var imei, s2s;
      if (payload.data.telephony) {
        imei = payload.data.telephony.imei;
      }

      if (payload.info && payload.info.serverToServer) {
        s2s = payload.info.serverToServer;
      }

      var method = _args.method || 'onPropertiesUpdate';

      var result = {
        method: method,
        onSuccess: !!_args.onSuccess,
        onError: !!_args.onError,
        storageType: _args.storageType,
        storageExpiry: _args.storageExpiry,
        entryPoint: _metrics.entryPoint
      };

      if (_scriptAttributes) {
        var scriptKeys = Object.keys(_scriptAttributes);
        for (var i = 0; i < scriptKeys.length; i++) {
          var key = scriptKeys[i];
          result[key] = _scriptAttributes[key];
        }
      }

      if (_args.urls) {
        result.urls = _args.urls;
      }

      if (typeof s2s !== 'undefined') {
        result.serverToServer = s2s;
      }

      if (typeof imei !== 'undefined') {
        result.imei = !!imei && imei.toString();
      }

      if (payload.info && payload.info.legacy) {
        result.legacy = true;
      }

      return result;
    }, options);

    if (configs && payload && payload.data && payload.data.web && payload.data.web.webview && payload.data.web.webview.jsProps) {
      payload.data.web.webview.jsProps.configs = configs;
    }
  }

  /**
   * Collects all the overrides that have been detected.
   *
   * @returns {{a: boolean, e: boolean}}
   * @private
   */
  function _collectOverrides() {
    var _callback = function () {
      if (!Object && Object.getOwnPropertyDescriptor && typeof Object.getOwnPropertyDescriptor === 'function') {
        return undefined;
      }

      var properties = [];

      if (document) {
        properties.push({
          object: document,
          name: 'document',
          properties: ['readyState', 'referrer']
        });
      }

      if (navigator) {
        properties.push({
          object: navigator,
          name: 'navigator',
          properties: [
            'userAgentData',
            'appCodeName',
            'appName',
            'appVersion',
            'brave',
            'buildID',
            'languages',
            'language',
            'platform',
            'userAgent',
            'hardwareConcurrency',
            'deviceMemory',
            'oscpu',
            'webdriver',
            'maxTouchPoints',
            'product',
            'bluetooth',
            'clipboard',
            'connection',
            'cookieEnabled',
            'hid',
            'ink',
            'geolocation',
            'plugins',
            'vendor',
            'vendorSub',
            'permissions',
            'serviceWorker',
            'getBattery'
          ]
        });

        if (navigator.permissions) {
          properties.push({
            object: navigator.permissions,
            name: 'navigator_permissions',
            properties: ['query']
          });
        }

        if (navigator.userAgentData) {
          properties.push({
            object: navigator.userAgentData,
            name: 'navigator_userAgentData',
            properties: ['getHighEntropyValues']
          });
        }
      }

      if (window) {
        properties.push({
          object: window,
          name: 'window',
          properties: [
            'indexedDB',
            'performance',
            'innerWidth',
            'innerHeight',
            'outerWidth',
            'outerHeight',
            'isSecureContext',
            'orientation',
            'statusbar',
            'toolbar',
            'visualViewport',
            'chrome',
            'opr',
            'opera',
            'origin',
            'safari',
            'screen',
            'speechSynthesis',
            'ApplePaySession',
          ]
        });

        if (window.screen) {
          properties.push({
            object: window.screen,
            name: 'window_screen',
            properties: ['width', 'height', 'deviceXDPI', 'deviceYDPI']
          });
        }

        if (window.performance && window.performance.memory) {
          properties.push({
            object: window.performance.memory,
            name: 'window_performance_memory',
            properties: ['jsHeapSizeLimit', 'totalJSHeapSize', 'usedJSHeapSize']
          });
        }
      }
      return _detectPropertyOverrides(properties);
    };


    var allOverrides = _collectData(_callback);
    var webGlOverrides = _detectWebGlOverrides();
    var htmlCanvasContextOverrides = _detectHTMLCanvasOverridesGetContext();

    if (webGlOverrides && webGlOverrides.a) {
      if (!allOverrides || (allOverrides && !allOverrides.v)) {
        allOverrides = { a: allOverrides.a, e: allOverrides.e, v: {} };
      }

      allOverrides.a = allOverrides.a || webGlOverrides.a;
      allOverrides.e = allOverrides.e || webGlOverrides.e;
      allOverrides.v.WebGLRenderingContext = webGlOverrides;
    }

    if (htmlCanvasContextOverrides && htmlCanvasContextOverrides.a) {
      if (!allOverrides || (allOverrides && !allOverrides.v)) {
        allOverrides = { a: allOverrides.a, e: allOverrides.e, v: {} };
      }

      allOverrides.a = allOverrides.a || htmlCanvasContextOverrides.a;
      allOverrides.e = allOverrides.e || htmlCanvasContextOverrides.e;
      allOverrides.v.HTMLCanvasElement = htmlCanvasContextOverrides;
    }

    return allOverrides;
  }

  /**
   * Creates a list of properties that have been overridden based off the properties passed in.
   * @param properties
   * @returns {*[]}
   * @private
   */
  var _detectPropertyOverrides = function (properties) {

    if (!properties || properties.length < 1) {
      return undefined;
    }
    var overrides;

    var _callback = function (args) {
      var obj = args.object;
      var prop = args.prop;

      var descriptor = Object.getOwnPropertyDescriptor(obj, prop);

      var _result = _buildCanvasOverrideResult(descriptor, ['enumerable', 'writable', 'configurable']);
      if (!_result) {
        return undefined;
      }

      if (descriptor.writable) {
        _result.writable = descriptor.writable.toString();
      }
      return Object.keys(_result).length > 0 ? _result : undefined;
    };

    var i, j;
    for (i = 0; i < properties.length; i++) {
      var obj = properties[i].object;
      var name = properties[i].name;
      var props = properties[i].properties || [];

      for (j = 0; j < props.length; j++) {

        var args = { object: obj, prop: props[j] };


        var _result = _collectData(_callback, args);
        if (_result && _result.a) {
          if (!overrides) {
            overrides = {};
          }
          overrides[name + '_' + args.prop] = _result;
        }
      }
    }
    return overrides;
  };

  /**
   * Initialises the DeviceAssure configurations
   *
   * @private
   */
  function _initDV(DV, _options) {
    var overridingOptions = null;

    if (window.DeviceAssure && window.DeviceAssure.options) {
      overridingOptions = window.DeviceAssure.options;
    }
    else if (window.DeviceValidation && window.DeviceValidation.options) {
      overridingOptions = _options;
    }
    else if (_options) {
      overridingOptions = _options;
    }

    if (!overridingOptions) {
      return;
    }

    _overriddenConfig = {};

    var options = _getDefaultOptions();

    if (overridingOptions.serverToServer === true) {
      options.s2s = overridingOptions.serverToServer;
      _overriddenConfig.s2s = true;
    }

    if (!!overridingOptions.licence) {
      options.licence = StringUtils.trim(overridingOptions.licence, ' ');
      _overriddenConfig.licence = true;
    }

    if (overridingOptions.hasOwnProperty('imei')) {
      options.imei = overridingOptions.imei;
      _overriddenConfig.imei = true;
    }
    else {
      delete options.imei;
    }

    if (overridingOptions.urls && overridingOptions.urls.length > 0) {

      var validUrls = [];
      for (var _i = 0; _i < overridingOptions.urls.length; _i++) {
        if (!overridingOptions.urls[_i]) {
          continue;
        }
        var url = StringUtils.trim(overridingOptions.urls[_i], ' ');
        if (url) {
          validUrls.push(url);
        }
      }

      options.urls = validUrls;
      options.customUrlMode = true;
      delete options.licence;
      _overriddenConfig.urls = true;
    }

    if (overridingOptions.onSuccess) {
      options.onSuccess = overridingOptions.onSuccess;
      _overriddenConfig.onSuccess = true;
    }

    if (overridingOptions.onError) {
      options.onError = overridingOptions.onError;
      _overriddenConfig.onError = true;
    }

    var _storageType = StringUtils.trim(overridingOptions.storageType, ' ');
    if ([STORAGE_TYPE.COOKIE, STORAGE_TYPE.LOCAL_STORAGE, STORAGE_TYPE.NONE].indexOf(_storageType) > -1) {
      options.sType = _storageType;
      _overriddenConfig.sType = true;
    }

    if (options.sType !== STORAGE_TYPE.NONE && overridingOptions.storageExpiry &&
      overridingOptions.storageExpiry > 0 && overridingOptions.storageExpiry <= DEFAULT_OPTIONS.TWENTY_FOUR_HOURS_IN_MILLIS) {

      options.sExpiry = overridingOptions.storageExpiry;
      _overriddenConfig.sExpiry = true;
    }

    if (_options && _options.method) {
      options.method = _options.method;
    }

    if (_options && _options.tags) {
      options.tags = CustomTags.validateTags(_options.tags);
    }

    if (_overriddenConfig.licence && _overriddenConfig.urls) {
      throw new Error('Licence key cannot be used in conjunction with custom urls');
    }

    VARIANT_ID = _generateVariantId();

    _globalOptions = options;

    return DV;
  }

  function _isCustomUrlMode() {
    if (!_globalOptions) {
      return false;
    }
    return (!_globalOptions.licence && _globalOptions.customUrlMode) || false;
  }

  /**
   * Return the DeviceAtlasCollector instance. This is the DeviceAtlas Clientside library
   * @returns {*}
   * @private
   */
  function _getDeviceAtlasCollector() {
    if (!_DeviceAtlasCollector) {
      _DeviceAtlasCollector = {};
    }

    return _DeviceAtlasCollector;
  }

  /**
   * Returns the DataCollector instance. This is the DeviceAssure library's collector
   * @returns {*}
   */
  function getDataCollector() {
    if (!DataCollector) {
      DataCollector = {};

      DataCollector.createPromiseCollection = function (args) {
        if (args && typeof args.collection === 'function' && isPromiseSupported()) {
          return new Promise(function(resolve, reject) {
            if (!apiData) {
              apiData = {};
            }
            args.collection({ resolve: resolve, reject: reject }, apiData);
          });
        }
        return null;
      };

      /**
       * Returns the async properties that need to be collected.
       * The name property isn't used anywhere, but helps with debugging.
       * @returns [{ name: string, collection: function }]
       */
      DataCollector.getAsyncProperties = function () {

        var collections = [
          { name: 'client_hint_lies',                   collection: _collectMinimumClientHints },
          { name: 'window_webkitRequestFileSystem',     collection: _collectWebkitRequestFileSystem },
          { name: 'window_indexedDB_createObjectStore', collection: _collectIndexedDBPersistence },
        ];

        var propertyCollections = NavigatorStorageCollector.getCollectionsForAsync();

        var _i;
        for (_i = 0; _i < propertyCollections.length; _i++) {
          collections.push(propertyCollections[_i]);
        }
        propertyCollections = NavigatorCollector.getCollectionsForAsync();
        for (_i = 0; _i < propertyCollections.length; _i++) {
          collections.push(propertyCollections[_i]);
        }
        return collections;
      };

      DataCollector.collectProperties = function (callback) {

        if (apiData || !isPromiseSupported()) {
          callback();
          return;
        }

        if (!apiData) {
          apiData = {};
        }

        var asyncProperties = DataCollector.getAsyncProperties();
        var collections = [];
        for (var _i = 0; _i < asyncProperties.length; _i++) {
          var promise = DataCollector.createPromiseCollection(asyncProperties[_i]);
          if (promise) {
            collections.push(promise);
          }
        }

        // Adding a promise to make sure we don't wait forever for the async properties to resolve.
        var timeoutPromise = new Promise(function(resolve, reject) {
          setTimeout(function() {
            apiData.promiseTimeout = true;
            resolve({ timeout: true });
          }, PROMISE_TIMEOUT);
        });

        _metrics.asyncStart = Date.now();
        Promise.race([Promise.all(collections), timeoutPromise]).then(function(results) {
          _metrics.asyncFinished = Date.now();

          var callbackArgs = {
            asyncStart: _metrics.asyncStart,
            asyncFinished: _metrics.asyncFinished
          };
          if (results && results.timeout) {
            callbackArgs.timeout = true;
          }
          callback(callbackArgs);
        });
      };

      /***
       * Triggers the collecting of the device data using the DA library, when doRequest is true, it will
       * perform the check call.
       *
       * @param type
       * @param doRequest
       */
      DataCollector.collect = function (type, doRequest) {

        var _collectNonBlockingProperties = function () {
          initIsAppleDevice();

          if (!type) {
            type = MESSAGE_TYPES.ON_LOAD;
          }

          if ((type === MESSAGE_TYPES.ON_LOAD || !doRequest) && isServerToServer(_globalOptions)) {
            // don't do any collection for server to server for the audioRef. It is done onPropertyUpdate
            return;
          }

          var noWait;

          // no audio ref, record we're missing it.
          if (isAppleDevice) {
            var audioRefProperties = !!missingProperties.audioRef ? missingProperties.audioRef : [];
            var attempt = _createMissingPropertyAttempt(audioRefProperties.length + 1, type);
            attempt.present = _hasAudioRef();

            // Flag that our audioRef was missing for this attempt.
            audioRefProperties.push(attempt);
            missingProperties.audioRef = audioRefProperties;

            noWait = attempt.present;
          } else {
            noWait = doRequest && (!isAppleDevice || _hasAudioRef());
          }


          if (noWait) {
            runCheckAuto(_globalOptions);
          } else {
            _asyncCheckForApple(DEFAULT_TIME_TO_WAIT, doRequest, type);
          }
        };

        getDataCollector().collectProperties(_collectNonBlockingProperties);
      };
    }

    return DataCollector;
  }

  /**
   * Set of rules for validation of a licence.
   * @param _licence
   * @param options
   * @returns {boolean}
   * @private
   */
  function _validateLicence(_licence, options) {

    if (_isCustomUrlMode()) {
      return true;
    }

    var rules = [
      {
        message: 'Invalid licence key.',
        valid: function (_value) {
          if (typeof _value !== 'string') {
            return false;
          }
          return true;
        }
      },
      {
        message: 'Invalid licence key.',
        valid: function (_value) {
          if (!_value || _value.indexOf('LICENCE') > -1) {
            return false;
          }
          return true;
        }
      },
      {
        message: 'Invalid licence key.',
        valid: function (_value) {
          var trimmedValue = StringUtils.trim(_value, ' ');

          if (!trimmedValue || !trimmedValue.length) {
            return false;
          }

          return true;
        }
      }
    ];
    for (var _i = 0; _i < rules.length; _i++) {
      if (rules[_i].valid(_licence)) {
        continue;
      }

      var disabledError = { message: rules[_i].message };

      if (options && options.onError) {
        options.onError(disabledError);
        return false;
      }
      throw disabledError;
    }

    return true;
  }

  /**
   * Returns the API client object.
   * getDeviceProperties - returns the device properties for the server to server check.
   * validateDevice - triggers the API call to check the device.
   * validateDeviceWithIMEI - triggers the API call to check the device for IMEI validation.
   * _loadLegacy - Loads the legacy mode of the DeviceAssure library.
   * load - Loads the DeviceAssure library.
   * @returns {*}
   */
  function getApiClient() {
    if (!ApiClient) {
      ApiClient = {};
      /**
       * Returns the server to server payload for the device validation check.
       *
       * @param args.callback - callback function to call with the payload
       * @returns {*}
       * @private
       */
      ApiClient.getDeviceProperties = function (args) {

        var callback = (args && args.callback) || undefined;

        if (!callback || propertiesLoadComplete || getPropertiesTimeoutInitialized) {
          return getPayloadData(callback, buildPayload, args);
        }

        getPropertiesTimeoutInitialized = true;
        setTimeout(function(callback, buildPayloadFunc, args) {
          return getPayloadData(callback, buildPayloadFunc, args);
        }, 1000, callback, buildPayload, args);
      };

      /**
       * Builds the Server to Server request with IMEI added to the payload
       * @param imei
       * @param params
       * @returns {*}
       */
      ApiClient.getDevicePropertiesWithIMEI = function (imei, params) {

        var options = params || {};
        var onSuccess = (options && options.onSuccess) || null;

        if (!IMEI.validate(imei, options, isImeiEnabled)) {
          return;
        }

        if (!onSuccess || propertiesLoadComplete || getPropertiesTimeoutInitialized) {
          return getPayloadData(onSuccess, _buildIMEIPayload, options);
        }

        getPropertiesTimeoutInitialized = true;
        setTimeout(function(callback, buildPayloadFunc, _params) {
          return getPayloadData(callback, buildPayloadFunc, _params);
        }, 1000, onSuccess, _buildIMEIPayload, params);
      };

      /**
       * Entrypoint method for the DeviceAssure library, used for legacy mode.
       * @param _options
       * @returns {{}}
       * @private
       */
      ApiClient._loadLegacy = function(_options) {
        var options = _getDefaultOptions();

        delete options.licence;
        if (!!_options.licence) {
          options.licence = _options.licence;
        }

        delete options.urls;
        if (!!_options.urls) {
          options.urls = _options.urls;
        }

        options.onSuccess = _options.onSuccess || options.onSuccess;
        options.onError = _options.onError || options.onError;

        options.storageType = _options.storageType;
        options.storageExpiry = _options.storageExpiry;

        delete options.imei;
        if (_options.imei) {
          options.imei = _options.imei;
        }

        if (_options.serverToServer) {
          options.serverToServer = _options.serverToServer;
        }

        _legacyMode = true;

        return ApiClient.load(options);
      };

      /**
       * Entrypoint method for the DeviceAssure library. This will initialise the DeviceAtlas library and start the
       * collection of our properties.
       *
       * This replaces the old setup of declaring DeviceAssure = { options: {} } etc.
       *
       * @param _options
       * @returns {{}}
       */
      ApiClient.load = function(_options) {
        _metrics.load = Date.now();

        if (!VARIANT_ID) {
          VARIANT_ID = _generateVariantId();
        }

        var options = _options || null;

        if (STORAGE_TYPE.NONE === _getStorageType(options)) {
          _overriddenConfig = null;
          _globalOptions = {};
          Library.options = null;
        }
        else {
          var existingCache = _getCacheValue(options);
          if (options && !!existingCache && typeof options.onSuccess === 'function' && !isServerToServer(options)) {
            // Don't load other JS, we have a cache.
            options.onSuccess(existingCache);
            _completeSession();
            return Library;
          }
        }

        if (!window.DeviceAtlasCollector) {
          _initDA(options);
        }

        if (!_overriddenConfig) {
          _initDV(Library, options);
        }

        if (_initialised > 0) {
          runCheckAuto(options);
        }

        return Library;
      };

      /**
       * Generates and displays a DeviceAssure QR code in the specified container.
       *   licence: string,
       *   size: number,
       *   json: boolean,
       *   scannedMessage: string,
       *   expiredMessage: string,
       *   lifecycle: string,
       *   redirect: string,
       *   responseDelay: number,
       *   deviceRedirect: string,
       *
       *   script: {
       *     nonce: string,
       *     async: boolean,
       *     defer: boolean
       *   }, // args for script tag
       *   selector: string, // CSS selector for the container to insert the QR code into
       *   callback: function // Callback function to handle messages
       * @param args
       */
      /* istanbul ignore next */
      ApiClient.qr = function (args) {
        Qr.generate(args);
      };

      /**
       * Parses the QR redirect data from the URL and triggers the callback function.
       * @param data - data from the URL to parse, leave empty to auto-detect
       */
      ApiClient.parseQrRedirect = function (data, args) {
        return Qr.parseRedirect(data, args);
      };


      /**
       * Init the entire library;
       * @returns {{}|*}
       */
      ApiClient.init = function () {
        _metrics.init = Date.now();

        if (document && document.currentScript) {
          if (!!document.currentScript.async) {
            _scriptAttributes.async = true;
          }

          if (!!document.currentScript.defer) {
            _scriptAttributes.defer = true;
          }

          if (!!document.currentScript.onload) {
            _scriptAttributes.onload = true;
          }

          if (document.currentScript.type) {
            _scriptAttributes.type = document.currentScript.type;
          }

          if (document.currentScript.src) {
            _scriptAttributes.src = btoa(document.currentScript.src);
          }
        }

        /**
         * The legacy configuration hook for the DeviceAssure library.
         *
         * This is needed for when DeviceAssure = { options: {} } is used. Please use DeviceAssure.load now.
         */

        var legacyOptions;
        if (window.DeviceAssure && !!window.DeviceAssure.options) {
          legacyOptions = window.DeviceAssure.options;
        }
        else if (window.DeviceValidation && !!window.DeviceValidation.options) {
          legacyOptions = window.DeviceValidation.options;
        }

        if (legacyOptions) {
          var apiClient = getApiClient();
          apiClient.initDeviceAssure(Library);
          return apiClient._loadLegacy(legacyOptions);
        }

        return getApiClient().initDeviceAssure(Library);
      };

      /**
       * Init the DeviceAssure library with the DeviceAssure object. Inserting in to the window
       *
       * This is where the public methods are defined.
       *
       * @param library
       * @returns {{}}
       */
      ApiClient.initDeviceAssure = function (library) {
        if (!window.DeviceAssure || !window.DeviceAssure.load) {
          Clients.generate(library, _metrics);
        }

        /* jshint ignore:start */
        
        /* jshint ignore:end */

        return library;
      };

      /**
       * Trigger to call the API check with the IMEI passed in. It will populate the data.telephony.imei and tac
       * @param imei
       * @param params
       * @returns {Promise|*|void}
       * @private
       */
      ApiClient.validateDeviceWithIMEI = function (imei, params) {
        var onSuccess = (params && params.onSuccess) || null;
        var onError = (params && params.onError) || null;
        var licence = (params && params.licence) || (_globalOptions && _globalOptions.licence) || '';

        var payload = (params && params.payload) || null;
        var overrideLoading = (params && params.overrideLoading) || false;

        var options = params || {};

        if (!_validateLicence(licence, options) || !IMEI.validate(imei, options, isImeiEnabled)) {
          return;
        }

        payload = _buildIMEIPayload({ licence: licence, imei: imei, payload: payload});

        return getApiClient().validateDevice({
          licence: licence,
          onSuccess: onSuccess,
          onError: onError,
          payload: payload,
          currentUrl: currentUrl,
          overrideLoading: overrideLoading,
          imei: imei,
          method: params && params.method
        });
      };

      /**
       * Method which loads the device assure library depending on the arguments passed in.
       *
       * @param params.licence - licence key
       * @param params.imei - IMEI
       * @param params.onSuccess - callback function to call on success
       * @param params.onError - callback function to call on error
       * @param params.payload - [optional] Payload to send to the API.
       * @param params.method - [optional] How the library was called.
       * @param params.currentUrl - [optional] Url to send the request to (used for failover)
       * @param params.overrideLoading - [optional] override the loading flag, this can help to prevent calling the api if there
       *                                 is some form of external loading that should be needed to block this.
       * @param params.overridingURLs - [optional] Override the urls to send the request to.
       * @param params.urls           - [optional] Alias for overridingURLs
       * @returns {Promise|any|void}
       */
      ApiClient.validateDevice = function (params) {
        var overrideLoading = (params && params.overrideLoading) || false;
        var onSuccess = (params && params.onSuccess) || function () {};
        var onError = (params && params.onError) || function () {};
        var licence = (params && params.licence) || undefined;
        var payload = (params && params.payload) || undefined;
        var currentUrl = (params && params.currentUrl) || undefined;
        var overridingURLs = (params && (params.overridingURLs || params.urls)) || undefined;
        var imei = (params && params.imei) || undefined;
        var method = (params && params.method) || null;
        var storageType = _getCurrentStorageType(params);

        if (loading && !overrideLoading) {
          return;
        }

        var cachedResponse = _getCacheValue();
        var hasNoCache = STORAGE_TYPE.NONE === storageType || !cachedResponse;

        var apiParams = {
          licence: licence,
          onSuccess: onSuccess,
          onError: onError,
          suppliedPayload: payload,
          currentUrl: currentUrl,
          overrideLoading: overrideLoading,
          urls: overridingURLs,
          imei: imei,
          method: method
        };

        if (hasNoCache) {
          return _doRequest(apiParams);
        }
        _completeSession();
        if (onSuccess) {
          onSuccess(cachedResponse);
        }
        return cachedResponse;
      };
    }

    return ApiClient;
  }

  /**
   * Entrypoint method for the DeviceAssure library.
   *
   * This is the main entry point for the library, it will initialise the DeviceAtlas library and start the
   * collection of the properties.
   *
   * It replaces the old setup of declaring DeviceAssure = { options: {} } etc.
   *
   * Please use this going forward.
   *
   * @param _options
   * @returns {{}}
   */
  Library.load = function(_options) {
    getApiClient().load(_options);
  };

  /**
   * Generates and displays a DeviceAssure QR code in the specified container.
   * @param _options
   */
  Library.qr = function(_options) {
    getApiClient().qr(_options);
  };

  /**
   * Parses the QR redirect data from the URL and triggers the callback function.
   * Leave data empty to auto-detect.
   * @param base64Data
   */
  Library.parseQrRedirect = function(base64Data, args) {
    return getApiClient().parseQrRedirect(base64Data, args);
  };

  /**
   * @deprecated - This method will be removed in future releases in favour of the load method.
   *
   * Function to return the payload for the device validation check.
   * accepts a callback function
   *
   * if callback is passed in then the callback is called with data else the payload is returned
   *
   * This will be removed in a future release, please use the async method in the future, some of the properties we
   * collect require a synchronous approach. For a more accurate result please use the async approach.
   *
   **/
  Library.getData = function(callback) {
    var args = { callback: callback, method: 'getData' };

    if (!window.DeviceAtlasCollector) {
      args.serverToServer = true;
      args.onSuccess = callback;

      DeviceAssure.load(args);
    }
    else {
      return getApiClient().getDeviceProperties(args);
    }

  };

  /**
   * @deprecated - This method will be removed in future releases in favour of the load method.
   *
   * Trigger to call the API check with the IMEI passed in. It will populate the data.telephony.imei and tac
   * properties if present.
   *
   * @param imei - IMEI value
   * @param params - contains options to override the default values in the library loaded in on page load.
   * @returns {Promise<unknown>}
   */
  Library.checkIMEI = function(imei, params) {
    var args = params || {};
    if (!args.method) {
      args.method = 'checkIMEI';
    }

    // For when the library wasn't loaded. Use the arguments from here.
    if (!window.DeviceAtlasCollector) {
      args.imei = imei;
      DeviceAssure.load(args);
    }
    else {
      return getApiClient().validateDeviceWithIMEI(imei, args);
    }
  };

  /**
   * @deprecated - This method will be removed in future releases in favour of the load method.     * Method which immediately calls the API to check the device.
   *
   * It is not recommended to use this method any more.
   *
   * If it is used on page load, it creates a race condition between the DeviceAtlas library and the API call.
   *
   * @param licence - licence key
   * @param onSuccess - callback function to call on success
   * @param onError - callback function to call on error
   * @param payload - [optional] Payload to send to the API.
   * @param currentUrl - [optional] Url to send the request to (used for failover)
   * @param overrideLoading - [optional] override the loading flag, this can help to prevent calling the api if there
   *                          is some form of external loading that should be needed to block this.
   * @param overridingURLs - [optional] Override the urls to send the request to.
   *
   * @returns {Promise|any|void}
   */
  Library.check = function(licence, onSuccess, onError, payload, currentUrl, overrideLoading, overridingURLs) {

    // For when the library wasn't loaded. Use the arguments from here.
    if (!window.DeviceAtlasCollector) {
      DeviceAssure.load({
        licence: licence,
        onSuccess: onSuccess,
        onError: onError,
        method: 'check'
      });
    }
    else {
      return getApiClient().validateDevice({
        licence: licence,
        onSuccess: onSuccess,
        onError: onError,
        payload: payload,
        currentUrl: currentUrl,
        overrideLoading: overrideLoading,
        urls: overridingURLs,
        method: 'check'
      });
    }
  };

  /**
   * Initialisation for the DeviceAtlas & DeviceAssure web library.
   *
   * If we don't have a cookie or our cookie has expired, we will start to collect the DeviceAtlas properties in the
   * background.
   *
   * If we have a cookie that has not expired, we make no attempt to initialise the DeviceAtlas library.
   *
   * If server to server configs are enabled, then we override whatever cookie we have and collect the data.
   *
   * The collection of the data is done by not adding a DeviceAtlas object in to the window.
   *
   * @params _options
   * @returns {{}|{cacheType: string, onPropertiesUpdate: _onPropertiesUpdate}}
   */
  function _initDA(_options) {
    // Documentation for DA: https://docs.deviceatlas.com/apis/clientside/latest/README.ClientSide.html
    // CDN: https://cs.deviceatlas-cdn.com/dacs.js
    // noinspection UnnecessaryLocalVariableJS
    var _DeviceAtlasConfig = {
      onPropertiesUpdate: _onPropertiesUpdate,
      cacheType: 'none', // This means we do not cache the DA result.
      dontStopPropertyUpdateEvents: false,
      waitMilliSecondsToBulkSendProperties: 1
    };

    window.DeviceAtlasCollector = _DeviceAtlasConfig;
    // var DeviceAtlasCollector = is imported here so the DeviceAtlasCollector will be in this scope.

    /* jshint ignore:start */
    /*
 * Copyright 2025 DeviceAtlas Limited. All rights reserved.
 * http://deviceatlas.com
 */
var DeviceAtlasCollector=function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=2)}([function(e,t,n){"use strict";n.r(t);var r=function(e){return"string"==typeof e&&e&&(e=function(e){return(e+"").replace(/"/g,'\\"')}(e=function(e){return(e+"").replace(/\\/g,"\\\\")}(e))),e},o=function(e){if(void 0!==(t=e)&&Array.isArray(t))return(function(e){return e.map((function(e){return'"'+r(e.brand)+'";v="'+e.version+'"'})).join(", ")}(e)+"").replace(/:/g," ");var t};function i(e){return void 0!==e&&""!==e?'"'+r(e)+'"':e}var u=new Promise((function(e){var t=navigator&&navigator.userAgentData,n=function(n){var r={},u=encodeURIComponent(i(t.platform)),a=encodeURIComponent(o(t.brands));void 0!==t.mobile&&(r.requestingMobileUx=t.mobile),void 0!==u&&(r["ch.platform"]=u),void 0!==a&&(r["ch.browserList"]=a),e(r)};if(t)try{t.getHighEntropyValues(["architecture","bitness","brands","formFactors","mobile","model","platform","platformVersion","uaFullVersion","fullVersionList","wow64"]).then((function(t){var n={platformArchitecture:t.architecture,requestingMobileUx:t.mobile,"ch.model":encodeURIComponent(i(t.model)),"ch.platform":encodeURIComponent(i(t.platform)),"ch.browserList":encodeURIComponent(o(t.brands)),"ch.browserFullVersionList":encodeURIComponent(o(t.fullVersionList)),"ch.platformVersion":encodeURIComponent(i(t.platformVersion)),"ch.uaFullVersion":encodeURIComponent(i(t.uaFullVersion)),"ch.formFactors":encodeURIComponent(i(t.formFactors)),"ch.wow64":t.wow64,"ch.bitness":t.bitness},r={};for(var u in n)null!=n[u]&&"undefined"!==n[u]&&"null"!==n[u]&&(r[u]=n[u]);e(r)})).catch(n)}catch(e){n()}else e({})}));t.default=u},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.addEventListener}},function(e,t,n){"use strict";n.r(t),n.d(t,"cacheProperty",(function(){return U}));var r=n(9),o=n.n(r),i=n(10),u=n(13),a=n(3),c="._.".length,s=["ch.model","ch.platform","ch.browserList","ch.browserFullVersionList","ch.platformVersion"],f=function(e,t,n){for(var r in void 0===t&&(t=!1),void 0===n&&(n={}),e){var o=t?t+"."+r:r,i=e[r],u=typeof e[r];"object"!==u||Array.isArray(i)?"function"!==u&&"undefined"!==u&&(n[o]=i):f(i,o,n)}return n},l=function(e,t,o){void 0===t&&(t=function(e){void 0===e&&(e=["_uaVerRef","animationFrameRate","audioRef","canvasNoise","ch.bitness","ch.browserFullVersionList","ch.browserList","ch.formFactors","ch.model","ch.platform","ch.platformVersion","ch.uaFullVersion","ch.wow64","connectionType","cookieSupport","css.animations","css.columns","css.transforms","css.transitions","ddg","deviceAspectRatio","devicePixelRatio","devicePosture","displayColorDepth","downlink","effectiveConnectionType","flashCapable","html.audio","html.canvas","html.inlinesvg","html.svg","html.video.ap4x","html.video.av1","html.video.av1016M08","html.video","js.accessDom","js.applicationCache","js.battery","js.deviceMotion","js.deviceOrientation","js.forceTouch","js.geoLocation","js.indexedDB","js.json","js.localStorage","js.modifyCss","js.modifyDom","js.querySelector","js.sessionStorage","js.supportBasicJavaScript","js.supportConsoleLog","js.supportEventListener","js.supportEvents","js.touchEvents","js.webGl","js.webGlRenderer","js.webSockets","js.webSqlDatabase","js.webWorkers","js.xhr","maxAudioChannelCount","mouseActivity","orientation","platformArchitecture","rendererRef","requestingMobileUx","roundTripTime","saveData","screenWidthHeight","shortestOpTime","supportsWebGpu","timeZone","usableDisplayHeight","usableDisplayWidth","userMedia","webGpuMaxBufferSize"]);var t={};e.map((function(e){t[e]=n(18)("./"+e+".js").default}));var o=function(){};return r.criticalProperties.map((function(e){t[e]=t[e]||o})),t}()),void 0===o&&(o=!1);var i=function(n){var r,i=e[n];if(i||!t.hasOwnProperty(n))return 1;var u=t[n],a=u.length<=1;try{r=u(i,(function(e){B.cacheProperty(n,e,i)}),e)}catch(e){B.debug(e)}(o||a)&&B.cacheProperty(n,r,i)};for(var u in t)i(u)},d=function(e,t,n,r,o){var c,f,l=(f=navigator.userAgent,"_uaRef"+Object(a.a)(f));if(o._uaRef=l,"cookie"===e||"local-storage"===e)return~(c="cookie"===e?function(e){if(!Object(i.default)())return"";for(var t=e+"=",n=document.cookie.split(";"),r=0;r<n.length;r++){for(var o=n[r];" "===o.charAt(0);)o=o.substring(1);if(0===o.indexOf(t)){var u=o.substring(t.length,o.length);'"'===u.charAt(0)&&(u=u.substr(1));var a=u.length-1;return'"'===u[a]&&(u=u.substring(0,a)),u}}return""}(r):function(e){if(!Object(u.default)())return"";var t=window.localStorage.getItem(e);if(!t)return"";var n="";try{n=JSON.parse(t)}catch(t){return localStorage.removeItem(e),""}return(new Date).getTime()>n.expiry?(localStorage.removeItem(e),""):n.value}(t)).indexOf(l)?function(e,t){if(!e||""===e)return t;for(var n=e.replace(/\%7C/g,"|").split("|"),r=0;r<n.length;r++){var o=n[r],i=o.indexOf("%3A"),u=!0;-1===i&&(u=!1,i=o.indexOf(":"));var a=o.substr(0,1),c=o.substr(1,i-1);if("timeTook"!==c&&"csVersion"!==c){var f=o.substring(i+(u?"%3A".length:":".length));switch(-1===s.indexOf(c)&&(f=decodeURIComponent(f)),a){case"i":t[c]=1*f;break;case"b":t[c]=!!(1*f);break;default:t[c]=f}}}return t}(c,o):o},v=(new Date).getTime(),p="undefined"!=typeof window&&window.DeviceAtlasCollector||{},m="function"==typeof p.debug?p.debug:p.debug&&console&&console.log?console.log:function(){},h=p.properties||{},g=p.cacheKey||"DAPROPS",y=p.cookieName||"DAPROPS",b=p.cacheType||"cookie",j=p.criticalProperties||o.a.criticalProperties,w=p.waitMilliSecondsToBulkSendProperties||3e3,x=p.cookieExpiryDays||1,k=p.cacheExpiryDays||1,O=p.dontStopPropertyUpdateEvents||!1,C=void 0!==p.encodeCookieValue&&Boolean(p.encodeCookieValue),E=p.cookieDomain||null,S=p.cookiePath||"/",T="function"==typeof p.onPropertiesUpdate?p.onPropertiesUpdate:function(){},P=!1,D=function(e,t){P&&!O||(T(e,t),P=!0)},A=[],R=!1,M=function(e,t){(function(e,t){if(!Array.isArray(e)||!Array.isArray(t))return!1;for(var n=0;n<e.length;n++)if(!~t.indexOf(e[n]))return!1;return!0})(j,A)&&(R&&(clearTimeout(R),R=!1),D(e,t))},L=function(){return(new Date).getTime()-v+"ms"},V=function(){return function(e){var t,n,r="";for(var o in e)e.hasOwnProperty(o)&&"timeTook"!==o&&"S"!==o&&"E"!==o&&(r+=(t="boolean"==typeof(n=e[o])?"b":"number"==typeof n&&n%1==0?"i":"s")+o+":"+("b"===t?e[o]+0:e[o])+"|");return"bS:0|"+r+"bE:0"}(F)},F={csVersion:"2.7.3"},U=function(e,t,n){if(A.push(e),void 0!==t&&null!=t&&t!==n)switch("object"==typeof t?function(e,t,n){var r=f(t,e),o=void 0;for(var i in r)if(void 0!==r[i]){var u=i.indexOf("._.");n[~u?i.substring(u+c):i]=r[i],o=o||!!r[i]}}(e,t,F):F[e]=t,b){case"cookie":!function(e,t){var n=t.cookieName,r=t.cookieExpiryDays,o=t.cookieDomain,u=t.cookiePath,a=t.encodeCookieValue;if(!Object(i.default)())return!1;var c=new Date;c.setDate(c.getDate()+r);var f="";null!=o&&(f=";domain="+o),a&&(e=e.split("|").map((function(e){var t=e.split(":",2),n=t[0].substring(1);return-1===s.indexOf(n)&&(t[1]=encodeURIComponent(t[1])),t.join("%3A")})).join("%7C")),document.cookie=n+'="'+e.replace(/;/g,"~")+'";expires='+c.toUTCString()+";path="+u+f}(V(),{cookieName:y,cookieDomain:E,cookieExpiryDays:x,cookiePath:S,encodeCookieValue:C});break;case"local-storage":!function(e,t,n){if(!Object(u.default)())return!1;var r=(new Date).getTime()+864e5*n;window.localStorage.setItem(t,JSON.stringify({value:e,expiry:r}))}(V(),g,k)}F.timeTook=L(),M(F,V())},B=t.default={cookieName:y,cookieDomain:E,cookieExpiryDays:x,cookiePath:S,onPropertiesUpdate:T,csVersion:"2.7.3",getPropertiesAsString:V,getProperties:function(){return F},properties:F,debug:m,cacheProperty:U,encodeCookieValue:C},_=!0;try{_=!0}catch(e){}_&&(d(b,g,0,y,F),A.push.apply(A,Object.keys(F)),l(F),l(F,h,!0),R=setTimeout((function(){F.timeTook=L(),D(F,V())}),w))},function(e,t,n){"use strict";t.a=function(e,t){t=t||5381;for(var n=0;n<e.length;n++)t=33*t^e.charCodeAt(n);return String(t>>>0)}},function(e,t,n){"use strict";var r=n(11),o=(n(2),["Webkit","Moz","O","ms","Khtml"]);t.a=function(e){var t=e.charAt(0).toUpperCase()+e.substr(1),n=(e+" "+o.join(t+" ")+t).split(" ");return Object(r.a)(n)}},function(e,t,n){"use strict";t.a=function(e){if(document.createElement)try{var t=document.createElement("video");if(t.canPlayType)switch(t.canPlayType(e)){case"":return!1;case"probably":return!0}}catch(e){}}},function(e,t,n){"use strict";var r=["webkit","moz","o","ms","khtml"];t.a=function(e,t){if(!!e[t])return!0;for(var n=t.charAt(0).toUpperCase()+t.substr(1),o=-1,i=r.length;++o<i;)if(e[r[o]+n])return!0;return!1}},function(e,t,n){"use strict";n.r(t);var r=navigator&&navigator.connection||{};t.default=r},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.CanvasRenderingContext2D}},function(e,t){e.exports={criticalProperties:["deviceAspectRatio","devicePixelRatio","js.webGlRenderer","screenWidthHeight","rendererRef","audioRef","js.deviceMotion","html.video.ap4x","html.video.av1","html.video.av1016M08","usableDisplayWidth","usableDisplayHeight","_uaVerRef","webGpuMaxBufferSize","animationFrameRate","supportsWebGpu","maxAudioChannelCount","canvasNoise","html.video.av1016M08","usableDisplayWidth","usableDisplayHeight","_uaVerRef","shortestOpTime"]}},function(e,t,n){"use strict";n.r(t),t.default=function(){return void 0===navigator.cookieEnabled&&"string"==typeof document.cookie||!!navigator.cookieEnabled}},function(e,t,n){"use strict";var r=n(2);t.a=function(e){if(!document.createElement)return null;if(null==r.default.divStyle&&(r.default.divStyle=document.createElement("div").style),void 0===r.default.divStyle)return null;for(var t in e)if(void 0!==r.default.divStyle[e[t]])return!0;return!1}},function(e,t,n){"use strict";t.a=function(e,t){if(void 0!==window.matchMedia)for(var n in t){if(window.matchMedia("("+e+":"+t[n]+")").matches)return t[n]+""}}},function(e,t,n){"use strict";n.r(t),t.default=function(){try{return!!localStorage.getItem}catch(e){return!1}}},function(e,t,n){"use strict";var r;t.a=function(){if(void 0!==r)return Promise.resolve(r);try{return navigator.gpu?navigator.gpu.requestAdapter().then((function(e){return e?r=e:0})).catch((function(e){return 0})):Promise.resolve(0)}catch(e){return r=0,Promise.resolve(0)}}},function(e,t,n){"use strict";var r,o=n(17),i=n.n(o);t.a=function(){if(void 0!==r)return r;var e=visualViewport.scale,t=document.createElement("div");t.style.cssText="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: -9996; display: block;",document.body.insertBefore(t,document.body.firstChild);var n=t.getBoundingClientRect();t.remove();var o=Math.round(n.width*e),u=Math.round(n.height*e);return r=o<u?{width:o,height:u}:{width:u,height:o},i()({},r)}},function(e,t,n){"use strict";n.r(t),t.default=function(){try{return window.screen.width+"/"+window.screen.height}catch(e){}}},function(e,t){function n(){return e.exports=n=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},e.exports.__esModule=!0,e.exports.default=e.exports,n.apply(null,arguments)}e.exports=n,e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r={"./_uaVerRef.js":19,"./animationFrameRate.js":20,"./audioRef.js":21,"./canvasNoise.js":22,"./ch.bitness.js":23,"./ch.browserFullVersionList.js":24,"./ch.browserList.js":25,"./ch.formFactors.js":26,"./ch.model.js":27,"./ch.platform.js":28,"./ch.platformVersion.js":29,"./ch.uaFullVersion.js":30,"./ch.wow64.js":31,"./connectionType.js":32,"./cookieSupport.js":10,"./css.animations.js":33,"./css.columns.js":34,"./css.transforms.js":35,"./css.transitions.js":36,"./ddg.js":37,"./deviceAspectRatio.js":38,"./devicePixelRatio.js":39,"./devicePosture.js":40,"./displayColorDepth.js":41,"./downlink.js":42,"./effectiveConnectionType.js":43,"./flashCapable.js":44,"./html.audio.js":45,"./html.canvas.js":8,"./html.inlinesvg.js":46,"./html.svg.js":47,"./html.video.ap4x.js":48,"./html.video.av1.js":49,"./html.video.av1016M08.js":50,"./html.video.js":51,"./js.accessDom.js":52,"./js.applicationCache.js":53,"./js.battery.js":54,"./js.deviceMotion.js":55,"./js.deviceOrientation.js":56,"./js.forceTouch.js":57,"./js.geoLocation.js":58,"./js.indexedDB.js":59,"./js.json.js":60,"./js.localStorage.js":13,"./js.modifyCss.js":61,"./js.modifyDom.js":62,"./js.querySelector.js":63,"./js.sessionStorage.js":64,"./js.supportBasicJavaScript.js":65,"./js.supportConsoleLog.js":66,"./js.supportEventListener.js":1,"./js.supportEvents.js":89,"./js.touchEvents.js":67,"./js.webGl.js":68,"./js.webGlRenderer.js":69,"./js.webSockets.js":70,"./js.webSqlDatabase.js":71,"./js.webWorkers.js":72,"./js.xhr.js":73,"./maxAudioChannelCount.js":74,"./mouseActivity.js":75,"./orientation.js":76,"./platformArchitecture.js":77,"./rendererRef.js":78,"./requestingMobileUx.js":79,"./roundTripTime.js":80,"./saveData.js":81,"./screenWidthHeight.js":16,"./shortestOpTime.js":82,"./supportsWebGpu.js":83,"./timeZone.js":84,"./usableDisplayHeight.js":85,"./usableDisplayWidth.js":86,"./userMedia.js":87,"./webGpuMaxBufferSize.js":88};function o(e){var t=i(e);return n(t)}function i(e){if(!n.o(r,e)){var t=new Error("Cannot find module '"+e+"'");throw t.code="MODULE_NOT_FOUND",t}return r[e]}o.keys=function(){return Object.keys(r)},o.resolve=i,e.exports=o,o.id=18},function(e,t,n){"use strict";n.r(t),t.default=function(e){if(void 0!==e)return e;var t=navigator.userAgent,n=t.indexOf("Version/");if(-1!==n){var r=n+"Version/".length,o=t.indexOf(" ",r),i=t.slice(r,o),u=parseInt(i,10);if(!Number.isNaN(u))return u}}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return e;try{var n=function(e,t){var n=document.createElement("div");return n.id=e,n.style.cssText="-webkit-transform: translateZ(0); transform: translateZ(0); -webkit-backface-visibility: hidden; backface-visibility: hidden; -webkit-perspective: 1000;"+t,n.style.willChange=(n.style.willChange?n.style.willChange+",":"")+"transform,scroll-position,contents,opacity",n},r=n("pn-scroll-box-min","position: absolute; left: -9999px; top: -9999px; width: 160px; height: 80px; overflow-y: scroll; scroll-behavior: smooth; background: transparent; opacity: 0; pointer-events: none;"),o=n("pn-scroll-content-min","height: 1200px; background: linear-gradient(180deg, #0d6efd 0%, #fd7e14 100%);");r.appendChild(o),document.body.appendChild(r);var i=!0;!function e(){r.scrollTo({top:r.scrollTop+300,behavior:"smooth"}),o.style.height=o.offsetHeight+300+"px",i&&requestAnimationFrame(e)}();var u={30:0,40:0,50:0,60:0,90:0,110:0,120:0},a=0;!function e(){requestAnimationFrame((function(n){requestAnimationFrame((function(o){if(function(e){u[10*~~(e/10)]++}(1e3/(o-n)),++a<6)e();else{i=!1,r.remove();var c=u[40]+u[110]+u[120],s=u[50]+u[60],f=u[20]+u[30],l=u[100]+u[120]+u[130]+u[140],d=u[50]+u[60]+u[20]+u[30]+u[40];t(l>d?"High":f>c+s?"Low":c>s?"ProMotion":"Standard")}}))}))}()}catch(e){}return""}},function(e,t,n){"use strict";n.r(t);var r=n(3);t.default=function(e,t){if(void 0!==e)return t(e);var n=null;try{if(!(n=new(window.OfflineAudioContext||window.webkitOfflineAudioContext)(1,44100,44100)))return t();var o=n.createOscillator();o.type="triangle",o.frequency.value=1e4;var i=n.createDynamicsCompressor();i.threshold&&(i.threshold.value=-50),i.knee&&(i.knee.value=40),i.ratio&&(i.ratio.value=12),i.reduction&&(i.reduction.value=-20),i.attack&&(i.attack.value=0),i.release&&(i.release.value=.25),o.connect(i),i.connect(n.destination),o.start(0),n.startRendering(),n.oncomplete=function(e){for(var n=!1,o=0;o<e.renderedBuffer.length;o++)n=Object(r.a)(e.renderedBuffer.getChannelData(0)[o].toString(),n);n&&t(n),i.disconnect()}}catch(e){t()}}},function(e,t,n){"use strict";n.r(t),t.default=function(e){if(void 0!==e)return e;try{if(void 0!==window.OffscreenCanvas){var t=new Uint8ClampedArray([255,0,0,255,255,0,0,255,0,0,255,255,0,0,255,255,255,0,0,255,255,0,0,255,0,0,255,255,0,0,255,255]),n=new OffscreenCanvas(4,2).getContext("2d");["#ff0000","#0000ff"].forEach((function(e,t){n.fillStyle=e,n.fillRect(2*t,0,2,2)}));for(var r=n.getImageData(0,0,4,2).data,o=0;o<r.length;o++)if(r[o]!==t[o])return!0}}catch(e){}return!1}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.bitness"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.browserFullVersionList"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.browserList"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.formFactors"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.model"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){n(0).default.then((function(e){t(e["ch.platform"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.platformVersion"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.uaFullVersion"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.wow64"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(7).default.type}},function(e,t,n){"use strict";n.r(t);var r=n(4);t.default=function(){return Object(r.a)("animationName")}},function(e,t,n){"use strict";n.r(t);var r=n(4);t.default=function(){return Object(r.a)("columnCount")}},function(e,t,n){"use strict";n.r(t);var r=n(11);t.default=function(){return!!Object(r.a)(["transformProperty","WebkitTransform","MozTransform","OTransform","msTransform"])}},function(e,t,n){"use strict";n.r(t);var r=n(4);t.default=function(){return Object(r.a)("transitionProperty")}},function(e,t,n){"use strict";n.r(t),t.default=function(){if(void 0!==navigator.duckduckgo)return{navigator:!0,platform:navigator.duckduckgo.platform}}},function(e,t,n){"use strict";n.r(t);var r=n(12),o=n(16);t.default=function(e){if(void 0!==e)return e;var t=["2/3","40/71","3/4","16/9","16/10","375/667","9/16","10/16","375/812","207/448"],n=Object(o.default)();return n&&t.push(n),Object(r.a)("device-aspect-ratio",t)}},function(e,t,n){"use strict";n.r(t),t.default=function(){var e=1;try{e=window.devicePixelRatio}catch(e){}return e+""}},function(e,t,n){"use strict";n.r(t),t.default=function(){var e,t=null==(e=navigator.devicePosture)?void 0:e.type;if(void 0!==t)return t}},function(e,t,n){"use strict";n.r(t),t.default=function(){return screen.colorDepth}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(7).default.downlink}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(7).default.effectiveType}},function(e,t,n){"use strict";n.r(t),t.default=function(){try{if(navigator.plugins&&navigator.plugins.length>0&&navigator.mimeTypes){var e="application/x-shockwave-flash";if(navigator.mimeTypes[e]&&navigator.mimeTypes[e].enabledPlugin)return!0}if("function"==typeof ActiveXObject||"object"==typeof ActiveXObject){var t=["ShockwaveFlash.ShockwaveFlash.7","ShockwaveFlash.ShockwaveFlash.7","ShockwaveFlash.ShockwaveFlash"];for(var n in t)try{return new ActiveXObject(t[n]),!0}catch(e){}}}catch(e){}return!1}},function(e,t,n){"use strict";n.r(t),t.default=function(e){if(void 0!==e)return e;if(!document.createElement)return!1;var t=document.createElement("audio");try{if(t.canPlayType){var n={};return n.ogg=""!==t.canPlayType('audio/ogg; codecs="vorbis"'),n.mp3=""!==t.canPlayType("audio/mpeg;"),n.wav=""!==t.canPlayType('audio/wav; codecs="1"'),n.m4a=""!==t.canPlayType("audio/x-m4a;"),n.m4a=""!=t.canPlayType("audio/aac;"),n}}catch(e){}return!1}},function(e,t,n){"use strict";n.r(t);t.default=function(e){if(void 0!==e)return e;if(!document.createElement)return!1;var t=document.createElement("div");return t.innerHTML="<svg/>","http://www.w3.org/2000/svg"==(t.firstChild&&t.firstChild.namespaceURI)}},function(e,t,n){"use strict";n.r(t);t.default=function(){return!!document.createElementNS&&!!document.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect}},function(e,t,n){"use strict";n.r(t);var r=n(5);t.default=function(e){return void 0!==e?e:Object(r.a)('video/quicktime; codecs="ap4x"')}},function(e,t,n){"use strict";n.r(t);var r=n(5);t.default=function(e){return void 0!==e?e:Object(r.a)('video/mp4; codecs="av01.0.05M.08"')}},function(e,t,n){"use strict";n.r(t);var r=n(5);t.default=function(e){return void 0!==e?e:Object(r.a)('video/mp4; codecs="av01.0.16M.08"')}},function(e,t,n){"use strict";n.r(t),t.default=function(e){if(void 0!==e)return e;if(!document.createElement)return!1;var t=document.createElement("video");try{if(t.canPlayType){var n={};n.ogg=""!==t.canPlayType('video/ogg; codecs="theora"');var r='video/mp4; codecs="avc1.42E01E';return n.h264=""!==t.canPlayType(r+'"')||""!==t.canPlayType(r+', mp4a.40.2"'),n.webm=""!==t.canPlayType('video/webm; codecs="vp8, vorbis"'),n}}catch(e){}return!1}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!document.getElementById&&!!document.getElementsByTagName&&!!document.getElementsByName}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.applicationCache}},function(e,t,n){"use strict";n.r(t),t.default=function(){var e=navigator.battery||navigator.webkitBattery||navigator.mozBattery;if(e)return e}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.DeviceMotionEvent}},function(e,t,n){"use strict";n.r(t);var r=n(1);t.default=function(e,t){if(void 0!==e)return t(e);if(!Object(r.default)())return t(!1);var n=function(e){null!=e&&null!=e.alpha?t(!0):null==e&&t(!1),window.removeEventListener("deviceorientation",n,{once:!0,capture:!0})};window.addEventListener("deviceorientation",n,{once:!0,capture:!0})}},function(e,t,n){"use strict";n.r(t);var r=n(1);t.default=function(e,t){if(void 0!==e)return t(e);if(!Object(r.default)())return t(!1);var n=!1,o=function(e){switch(e.type){case"touchforcechange":try{var r=e.touches[0];"direct"==r.touchType&&r.force>=.01&&(n=!0,t(!0)),window.removeEventListener("touchforcechange",o,!1)}catch(e){}break;case"touchend":n||t(!1);try{window.removeEventListener("touchend",o,!1)}catch(e){}}};window.addEventListener("touchforcechange",o,{once:!0,capture:!0}),window.addEventListener("touchend",o,{once:!0,capture:!0})}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!navigator.geolocation}},function(e,t,n){"use strict";n.r(t);var r=n(6);t.default=function(){return Object(r.a)(window,"indexedDB")}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"object"==typeof JSON&&"function"==typeof JSON.stringify}},function(e,t,n){"use strict";n.r(t),t.default=function(){if(!document.createElement)return!1;var e=document.createElement("div");return"object"==typeof e.style&&void 0!==e.style.display&&(e.style.display="none","none"==e.style.display)}},function(e,t,n){"use strict";n.r(t),t.default=function(){if(!document.createElement||!document.appendChild)return!1;var e=document.createElement("span"),t=document.createElement("div");return t.appendChild(e),t==e.parentNode}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!document.querySelector}},function(e,t,n){"use strict";n.r(t),t.default=function(){try{return!!sessionStorage.getItem}catch(e){return!1}}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"function"==typeof alert&&"function"==typeof confirm&&"function"==typeof setTimeout&&"function"==typeof setInterval&&(!!document.location&&!!document.forms)}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"object"==typeof console&&"function"==typeof console.log}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"ontouchstart"in window||navigator&&navigator.pointerEnabled&&navigator.msMaxTouchPoints>1}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.WebGLRenderingContext}},function(e,t,n){"use strict";n.r(t);var r=n(8);t.default=function(e){if(void 0!==e)return e;if(Object(r.default)()){var t=document.createElement("canvas"),n=t.getContext("webgl")||t.getContext("experimental-webgl");if(n){var o=n.getExtension("WEBGL_debug_renderer_info");if(o){var i=n.getParameter(o.UNMASKED_RENDERER_WEBGL);if(i)return i}}}}},function(e,t,n){"use strict";n.r(t);var r=n(6);t.default=function(){return Object(r.a)(window,"WebSocket")}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.openDatabase}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.Worker}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"function"==typeof XMLHttpRequest||"object"==typeof XMLHttpRequest}},function(e,t,n){"use strict";n.r(t),t.default=function(e){if(void 0!==e)return e;try{var t=new AudioContext,n=t.destination.maxChannelCount;return t.close(),t=null,n}catch(e){return 0}}},function(e,t,n){"use strict";n.r(t);var r=n(1);t.default=function(e,t){if(void 0!==e)return t(e);if(!Object(r.default)())return t(!1);var n=function(){t(!0);try{window.removeEventListener("mousemove",n,!1)}catch(e){}};window.addEventListener("mousemove",n,{once:!0,capture:!0})}},function(e,t,n){"use strict";n.r(t),t.default=function(){return window.orientation}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){var n=e.platformArchitecture;t(n)}))}},function(e,t,n){"use strict";n.r(t);var r=n(8),o=n(12),i=n(3);t.default=function(e){if(void 0!==e)return e;if(Object(r.default)()){var t=document.createElement("canvas"),n=t.getContext("2d"),u="DeviceAtlas";return n.textBaseline="top",n.font="16px 'Arial'",n.textBaseline="alphabetic",n.rotate(.05),n.fillStyle="#f60",n.fillRect(125,1,62,20),n.fillStyle="#069",n.fillText(u,2,15),n.fillStyle="rgba(102, 200, 0, 0.7)",n.fillText(u,4,17),n.shadowBlur=10,n.shadowColor="blue",n.rotate(-.15),n.fillRect(-20,25,234,5),("p3"===Object(o.a)("color-gamut",["p3"])?"1":"0")+Object(i.a)(t.toDataURL())}}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){var n=e.requestingMobileUx;t(n)}))}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(7).default.rtt}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(7).default.saveData}},function(e,t,n){"use strict";n.r(t),t.default=function(e){if(void 0!==e)return e;var t=performance;if(void 0===t)return 0;function n(){for(var e=0,t=0;t<10;t++)r(),e+=o();if(e){var n=r();return(r()-n)/(e/10)}return 0}function r(){for(var e=0,n=t.now();(e=t.now())==n;);return e}function o(){for(var e,n=0,r=t.now();(e=t.now())==r;);for(;t.now()==e;)n++;return n}for(var i=[],u=0;u<7;u++)i.push(n());var a=i.sort((function(e,t){return e-t}))[0];return Math.trunc(1e6*a)}},function(e,t,n){"use strict";n.r(t);var r=n(14);t.default=function(e,t){if(void 0!==e)return e;Object(r.a)().then((function(e){t(!!e)}))}},function(e,t,n){"use strict";n.r(t),t.default=function(){var e;if("undefined"!=typeof Intl)return null==(e=Intl.DateTimeFormat())||null==(e=e.resolvedOptions())?void 0:e.timeZone}},function(e,t,n){"use strict";n.r(t);var r=n(15);t.default=function(e){return void 0!==e?e:Object(r.a)().height}},function(e,t,n){"use strict";n.r(t);var r=n(15);t.default=function(e){return void 0!==e?e:Object(r.a)().width}},function(e,t,n){"use strict";n.r(t);var r=n(6);t.default=function(){return Object(r.a)(navigator,"getUserMedia")}},function(e,t,n){"use strict";n.r(t);var r=n(14);t.default=function(e,t){if(void 0!==e)return e;Object(r.a)().then((function(e){t(String(e?e.limits.maxBufferSize:0))})).catch((function(e){return t(String(0))}))}},function(e,t,n){"use strict";n.r(t);var r=function(e,t){if(!document.createElement)return!1;var n=document.createElement(t),r=(e="on"+e)in n;return r||(n.setAttribute||(n=document.createElement("div")),n.setAttribute&&n.removeAttribute&&(n.setAttribute(e,""),r="function"==typeof n[e])),r};t.default=function(){var e={submit:"form",click:"input",change:"input",load:"img",select:"input"};for(var t in e)if(!r(t,e[t]))return!1;return!0}}]).default;

    /* jshint ignore:end */
    // Library is now loaded after this point as the DA library will look for window.DeviceAtlasCollector.

    _DeviceAtlasCollector = DeviceAtlasCollector; // this will be there after the lib is imported by grunt.

    return _DeviceAtlasCollector;
  }

  return getApiClient().init();
})({
  window: window,
  document: document,
  navigator: navigator
});


/***/ }),

/***/ 718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* istanbul ignore next */

/**
 * Class for validating IMEI
 * @type {{validate: function(*)}}
 */
var IMEI = {
  /**
   * Validates the IMEI according to the rules defined.
   *
   * @param imei
   * @param options
   * @param opinion - Extra condition function that returns boolean
   *
   * @returns {boolean}
   */
  validate: function (imei, options, opinion) {
    var rules = [
      {
        message: 'IMEI is not a string.',
        valid: function (_imei) {
          // conditions for when the IMEI is not a string. (usually is from a input field)
          return typeof _imei === 'string';
        }
      },
      {
        message: 'IMEI is not present, please provide one.',
        valid: function (_imei) {
          var StringUtils = __webpack_require__(151);

          var trimmedImei = StringUtils.trim(_imei, ' ');

          var _opinion = opinion || function () { return true; };

          // Conditions for when the imei is all whitespace
          if (!trimmedImei || !_opinion(options)) {
            return false;
          }
          return true;
        }
      }
    ];
    for (var _i = 0; _i < rules.length; _i++) {
      if (rules[_i].valid(imei)) {
        continue;
      }

      var disabledError = { message: rules[_i].message };

      if (options && options.onError) {
        options.onError(disabledError);
        return false;
      }
      throw disabledError;
    }

    return true;
  }
};

module.exports = IMEI;


/***/ }),

/***/ 782:
/***/ (function(module) {

/* jshint strict: false */

var _createCommonObject = function () {
  return { a: false, e: false };
};

/**
 * Common Format for a lot of newer properties
 * @param dataFunction
 * @param args
 * @returns {{a: boolean, e: boolean}}
 * @private
 */
var _collectData = function (dataFunction, args) {
  var data = _createCommonObject();

  try {
    var result = dataFunction(args);
    if (typeof result !== 'undefined') {
      data.a = true;
      data.v = result;
    }
  }
  catch (e) {
    data.e = true;
  }

  return data;
};


var Common = {
  createCommonObject: _createCommonObject,
  collectData: _collectData
};

module.exports =  Common;


/***/ }),

/***/ 803:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* istanbul ignore next */
/**
 * Class for validating Custom Tags.
 *
 * @type {{validateTags: function(*), validateTag: function(*)}}
 */
var Tags = {

  /**
   * Validate the tag key and value
   * @param key
   * @param value
   */
  validateTag: function (key, value) {

    var rangeCheck = function (field, _value, min, max, extra) {
      if (_value && (_value.length < min || _value.length > max)) {
        var msg = 'Tag ' + field + ' must be between ' + min + ' and ' + max + ' characters';
        if (extra) {
          msg = msg + ', ' + extra;
        }
        throw new Error(msg);
      }
    };

    var typeCheck = function (field, _value, expected, extra) {
      if (typeof _value !== expected) {
        var msg = 'Tag ' + field + ' must be a ' + expected;
        if (extra) {
          msg = msg + ', ' + extra;
        }
        throw new Error(msg);
      }
    };

    var isAllSpaces = function (field, _value, extra) {
      var StringUtils = __webpack_require__(151);

      var sanitized = StringUtils.trim(_value, ' ');
      if (sanitized.length <= 0) {
        var msg = 'Tag ' + field + ' must not be empty';
        if (extra) {
          msg = msg + ', ' + extra;
        }
        throw new Error(msg);
      }
    };

    var containsSeparator = function (field, _value, extra) {
      var StringUtils = __webpack_require__(151);

      if (_value.indexOf(StringUtils.__STRING_SEPARATOR) > -1) {
        var msg = 'Tag ' + field + ' must not contain the separator "' + StringUtils.__STRING_SEPARATOR + '"';
        if (extra) {
          msg = msg + ', ' + extra;
        }
        throw new Error(msg);
      }
    };

    var tagRules = [
      { id: 'tag-key-type',    validation: function() { typeCheck('key', key, 'string', 'for key: "' + key + '"'); } },
      { id: 'tag-key-length',  validation: function() { rangeCheck('key', key, 1, 64, 'for key: "' + key + '"'); } },
      { id: 'tag-key-spaces',  validation: function() { isAllSpaces('key', key, 'for key: "' + key + '"'); } },
      { id: 'tag-key-separator',  validation: function() { containsSeparator('key', key, 'for key: "' + key + '"'); } },

      { id: 'tag-value-type',   validation: function() { typeCheck('value', value, 'string', 'for key: "' + key + '"'); } },
      { id: 'tag-value-length', validation: function() { rangeCheck('value', value, 1, 128, 'for key: "' + key + '"'); } },
      { id: 'tag-value-spaces', validation: function() { isAllSpaces('value', value, 'for key: "' + key + '"'); } },
    ];

    for (var i = 0; i < tagRules.length; i++) {
      tagRules[i].validation();
    }
  },

  /**
   * Converts a list of objects to a single object, in the format of [{ key: value }, {key1: value2}], becomes
   * { key: value, key1: value2 }
   *
   *
   * @param tags
   * @returns {null}
   */
  validateTags: function(tags) {
    var StringUtils = __webpack_require__(151);

    if (!tags || tags.length <= 0) {
      return null;
    }

    var _tags = null;
    for (var i = 0; i < tags.length; i++) {

      var tag = tags[i];

      if (!tag) {
        throw new Error('Missing tag arguments');
      }

      if (!tag.hasOwnProperty('key')) {
        throw new Error('Missing tag property "key"');
      }

      if (!tag.hasOwnProperty('value')) {
        throw new Error('Missing tag property "value"');
      }

      Tags.validateTag(tag.key, tag.value);

      if (!_tags) {
        _tags = {};
      }
      var _key = StringUtils.trim(tag.key, ' ');
      _tags[i + StringUtils.__STRING_SEPARATOR + _key] = StringUtils.trim(tag.value, ' ');
    }

    if (!_tags || Object.keys(_tags).length <= 0) {
      throw new Error('Invalid tag arguments');
    }

    return _tags;
  }
};

module.exports = Tags;


/***/ }),

/***/ 865:
/***/ (function(module) {


var HttpStatus = {
  values: {
    OK: 200,
    ACCEPTED: 202,
    BAD_REQUEST: 400,
    CONFLICT: 409,
    GONE: 410,
    UNPROCESSABLE_ENTITY: 422,
    TOO_MANY_REQUEST: 429
  },

  isOk: function(status) {
    if (typeof status === 'undefined') {
      return false;
    }

    return HttpStatus.values.OK === status || HttpStatus.values.ACCEPTED === status;
  },

  isError: function(status) {
    if (typeof status === 'undefined') {
      return false;
    }
    return HttpStatus.values.BAD_REQUEST <= status;
  },

  // Check if the status code should be ignored for retries
  isIgnored: function (status) {
    if (typeof status === 'undefined') {
      return false;
    }

    // status not to retry on
    return [
      HttpStatus.values.CONFLICT,
      HttpStatus.values.GONE,
      HttpStatus.values.TOO_MANY_REQUEST,
      HttpStatus.values.UNPROCESSABLE_ENTITY
    ].indexOf(status) > -1;
  }
};

module.exports = HttpStatus;


/***/ }),

/***/ 897:
/***/ (function(module) {

var HttpRequestState = {
  UNSENT: 0,
  OPENED: 1,
  HEADERS_RECEIVED: 2,
  LOADING: 3,
  DONE: 4
};

module.exports = HttpRequestState;


/***/ }),

/***/ 922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* jshint strict: false */

/* unused reexport */ __webpack_require__(566);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(922);
/******/ 	
/******/ })()
;